
// Auto-generated component loader for production
import Component_SwiperProductCallery from '~/components/section/SwiperProductCallery.vue'
import Component_SwiperProductCallery_Meta from '~/components/section/SwiperProductCallery.vue?builder=true'
import Component_badge_TextDescriptionBgHead from '~/components/section/badge/TextDescriptionBgHead.vue'
import Component_badge_TextDescriptionBgHead_Meta from '~/components/section/badge/TextDescriptionBgHead.vue?builder=true'
import Component_banner_CountdownBanner from '~/components/section/banner/CountdownBanner.vue'
import Component_banner_CountdownBanner_Meta from '~/components/section/banner/CountdownBanner.vue?builder=true'
import Component_banner_RatingWithText from '~/components/section/banner/RatingWithText.vue'
import Component_banner_RatingWithText_Meta from '~/components/section/banner/RatingWithText.vue?builder=true'
import Component_bonus_PromoBundle from '~/components/section/bonus/PromoBundle.vue'
import Component_bonus_PromoBundle_Meta from '~/components/section/bonus/PromoBundle.vue?builder=true'
import Component_charts_SavingCalculator from '~/components/section/charts/SavingCalculator.vue'
import Component_charts_SavingCalculator_Meta from '~/components/section/charts/SavingCalculator.vue?builder=true'
import Component_content_BackgroundTextImage from '~/components/section/content/BackgroundTextImage.vue'
import Component_content_BackgroundTextImage_Meta from '~/components/section/content/BackgroundTextImage.vue?builder=true'
import Component_content_BenefitsShowcase from '~/components/section/content/BenefitsShowcase.vue'
import Component_content_BenefitsShowcase_Meta from '~/components/section/content/BenefitsShowcase.vue?builder=true'
import Component_content_BundleOfferShowcase from '~/components/section/content/BundleOfferShowcase.vue'
import Component_content_BundleOfferShowcase_Meta from '~/components/section/content/BundleOfferShowcase.vue?builder=true'
import Component_content_ContentShowcase from '~/components/section/content/ContentShowcase.vue'
import Component_content_ContentShowcase_Meta from '~/components/section/content/ContentShowcase.vue?builder=true'
import Component_content_DecisionOptionsWithCTA from '~/components/section/content/DecisionOptionsWithCTA.vue'
import Component_content_DecisionOptionsWithCTA_Meta from '~/components/section/content/DecisionOptionsWithCTA.vue?builder=true'
import Component_content_DescriptionCtaImage from '~/components/section/content/DescriptionCtaImage.vue'
import Component_content_DescriptionCtaImage_Meta from '~/components/section/content/DescriptionCtaImage.vue?builder=true'
import Component_content_ExpertInsight from '~/components/section/content/ExpertInsight.vue'
import Component_content_ExpertInsight_Meta from '~/components/section/content/ExpertInsight.vue?builder=true'
import Component_content_FeatureHighlightButtons from '~/components/section/content/FeatureHighlightButtons.vue'
import Component_content_FeatureHighlightButtons_Meta from '~/components/section/content/FeatureHighlightButtons.vue?builder=true'
import Component_content_FeatureIconsWithImage from '~/components/section/content/FeatureIconsWithImage.vue'
import Component_content_FeatureIconsWithImage_Meta from '~/components/section/content/FeatureIconsWithImage.vue?builder=true'
import Component_content_FeatureInfoIconsImage from '~/components/section/content/FeatureInfoIconsImage.vue'
import Component_content_FeatureInfoIconsImage_Meta from '~/components/section/content/FeatureInfoIconsImage.vue?builder=true'
import Component_content_FeatureWithIconsAndCTA from '~/components/section/content/FeatureWithIconsAndCTA.vue'
import Component_content_FeatureWithIconsAndCTA_Meta from '~/components/section/content/FeatureWithIconsAndCTA.vue?builder=true'
import Component_content_FeatureWithIconsAndImage from '~/components/section/content/FeatureWithIconsAndImage.vue'
import Component_content_FeatureWithIconsAndImage_Meta from '~/components/section/content/FeatureWithIconsAndImage.vue?builder=true'
import Component_content_FeatureWithImage from '~/components/section/content/FeatureWithImage.vue'
import Component_content_FeatureWithImage_Meta from '~/components/section/content/FeatureWithImage.vue?builder=true'
import Component_content_FeatureWithImageAndBenefits from '~/components/section/content/FeatureWithImageAndBenefits.vue'
import Component_content_FeatureWithImageAndBenefits_Meta from '~/components/section/content/FeatureWithImageAndBenefits.vue?builder=true'
import Component_content_FeatureWithImageAndIcons from '~/components/section/content/FeatureWithImageAndIcons.vue'
import Component_content_FeatureWithImageAndIcons_Meta from '~/components/section/content/FeatureWithImageAndIcons.vue?builder=true'
import Component_content_GridFeatureIconsWithImage from '~/components/section/content/GridFeatureIconsWithImage.vue'
import Component_content_GridFeatureIconsWithImage_Meta from '~/components/section/content/GridFeatureIconsWithImage.vue?builder=true'
import Component_content_GridItemsButton from '~/components/section/content/GridItemsButton.vue'
import Component_content_GridItemsButton_Meta from '~/components/section/content/GridItemsButton.vue?builder=true'
import Component_content_HeadlineWithIconList from '~/components/section/content/HeadlineWithIconList.vue'
import Component_content_HeadlineWithIconList_Meta from '~/components/section/content/HeadlineWithIconList.vue?builder=true'
import Component_content_IconFeatureGrid from '~/components/section/content/IconFeatureGrid.vue'
import Component_content_IconFeatureGrid_Meta from '~/components/section/content/IconFeatureGrid.vue?builder=true'
import Component_content_IconsListBlockCta from '~/components/section/content/IconsListBlockCta.vue'
import Component_content_IconsListBlockCta_Meta from '~/components/section/content/IconsListBlockCta.vue?builder=true'
import Component_content_IconsTextWithVisualSection from '~/components/section/content/IconsTextWithVisualSection.vue'
import Component_content_IconsTextWithVisualSection_Meta from '~/components/section/content/IconsTextWithVisualSection.vue?builder=true'
import Component_content_ImageLeftTextRight from '~/components/section/content/ImageLeftTextRight.vue'
import Component_content_ImageLeftTextRight_Meta from '~/components/section/content/ImageLeftTextRight.vue?builder=true'
import Component_content_InfoContentImage from '~/components/section/content/InfoContentImage.vue'
import Component_content_InfoContentImage_Meta from '~/components/section/content/InfoContentImage.vue?builder=true'
import Component_content_InfoWithFullILeftmage from '~/components/section/content/InfoWithFullILeftmage.vue'
import Component_content_InfoWithFullILeftmage_Meta from '~/components/section/content/InfoWithFullILeftmage.vue?builder=true'
import Component_content_InfoWithFullILeftmageStyleTwo from '~/components/section/content/InfoWithFullILeftmageStyleTwo.vue'
import Component_content_InfoWithFullILeftmageStyleTwo_Meta from '~/components/section/content/InfoWithFullILeftmageStyleTwo.vue?builder=true'
import Component_content_InfoWithFullRightImage from '~/components/section/content/InfoWithFullRightImage.vue'
import Component_content_InfoWithFullRightImage_Meta from '~/components/section/content/InfoWithFullRightImage.vue?builder=true'
import Component_content_InfoWithFullRightImageStyleTwo from '~/components/section/content/InfoWithFullRightImageStyleTwo.vue'
import Component_content_InfoWithFullRightImageStyleTwo_Meta from '~/components/section/content/InfoWithFullRightImageStyleTwo.vue?builder=true'
import Component_content_InfoWithLeftImage from '~/components/section/content/InfoWithLeftImage.vue'
import Component_content_InfoWithLeftImage_Meta from '~/components/section/content/InfoWithLeftImage.vue?builder=true'
import Component_content_InfoWithRightImage from '~/components/section/content/InfoWithRightImage.vue'
import Component_content_InfoWithRightImage_Meta from '~/components/section/content/InfoWithRightImage.vue?builder=true'
import Component_content_PriceComparison from '~/components/section/content/PriceComparison.vue'
import Component_content_PriceComparison_Meta from '~/components/section/content/PriceComparison.vue?builder=true'
import Component_content_ProductInfoWithVisual from '~/components/section/content/ProductInfoWithVisual.vue'
import Component_content_ProductInfoWithVisual_Meta from '~/components/section/content/ProductInfoWithVisual.vue?builder=true'
import Component_content_ProductOffer from '~/components/section/content/ProductOffer.vue'
import Component_content_ProductOffer_Meta from '~/components/section/content/ProductOffer.vue?builder=true'
import Component_content_References from '~/components/section/content/References.vue'
import Component_content_References_Meta from '~/components/section/content/References.vue?builder=true'
import Component_content_TextDescriptionBonus from '~/components/section/content/TextDescriptionBonus.vue'
import Component_content_TextDescriptionBonus_Meta from '~/components/section/content/TextDescriptionBonus.vue?builder=true'
import Component_content_TextDescriptionCompareBlock from '~/components/section/content/TextDescriptionCompareBlock.vue'
import Component_content_TextDescriptionCompareBlock_Meta from '~/components/section/content/TextDescriptionCompareBlock.vue?builder=true'
import Component_content_TextDescriptionFullImage from '~/components/section/content/TextDescriptionFullImage.vue'
import Component_content_TextDescriptionFullImage_Meta from '~/components/section/content/TextDescriptionFullImage.vue?builder=true'
import Component_content_TextImageSplit from '~/components/section/content/TextImageSplit.vue'
import Component_content_TextImageSplit_Meta from '~/components/section/content/TextImageSplit.vue?builder=true'
import Component_content_TextImageSplitIngredients from '~/components/section/content/TextImageSplitIngredients.vue'
import Component_content_TextImageSplitIngredients_Meta from '~/components/section/content/TextImageSplitIngredients.vue?builder=true'
import Component_content_TextRightImage from '~/components/section/content/TextRightImage.vue'
import Component_content_TextRightImage_Meta from '~/components/section/content/TextRightImage.vue?builder=true'
import Component_content_TitleInfoPriceProduct from '~/components/section/content/TitleInfoPriceProduct.vue'
import Component_content_TitleInfoPriceProduct_Meta from '~/components/section/content/TitleInfoPriceProduct.vue?builder=true'
import Component_content_TitleInfoSmall from '~/components/section/content/TitleInfoSmall.vue'
import Component_content_TitleInfoSmall_Meta from '~/components/section/content/TitleInfoSmall.vue?builder=true'
import Component_content_TitlePointsInfoBox from '~/components/section/content/TitlePointsInfoBox.vue'
import Component_content_TitlePointsInfoBox_Meta from '~/components/section/content/TitlePointsInfoBox.vue?builder=true'
import Component_content_TitleWithParagraphLead from '~/components/section/content/TitleWithParagraphLead.vue'
import Component_content_TitleWithParagraphLead_Meta from '~/components/section/content/TitleWithParagraphLead.vue?builder=true'
import Component_content_VisualUseCasesFlow from '~/components/section/content/VisualUseCasesFlow.vue'
import Component_content_VisualUseCasesFlow_Meta from '~/components/section/content/VisualUseCasesFlow.vue?builder=true'
import Component_content_logoRightText from '~/components/section/content/logoRightText.vue'
import Component_content_logoRightText_Meta from '~/components/section/content/logoRightText.vue?builder=true'
import Component_cta_button from '~/components/section/cta/button.vue'
import Component_cta_button_Meta from '~/components/section/cta/button.vue?builder=true'
import Component_cta_buttonWithText from '~/components/section/cta/buttonWithText.vue'
import Component_cta_buttonWithText_Meta from '~/components/section/cta/buttonWithText.vue?builder=true'
import Component_ctas_CTAWithBadge from '~/components/section/ctas/CTAWithBadge.vue'
import Component_ctas_CTAWithBadge_Meta from '~/components/section/ctas/CTAWithBadge.vue?builder=true'
import Component_elements_CalculatorSavingsProjection from '~/components/section/elements/CalculatorSavingsProjection.vue'
import Component_elements_CalculatorSavingsProjection_Meta from '~/components/section/elements/CalculatorSavingsProjection.vue?builder=true'
import Component_faq_accordion from '~/components/section/faq/accordion.vue'
import Component_faq_accordion_Meta from '~/components/section/faq/accordion.vue?builder=true'
import Component_faqs_FAQWithImage from '~/components/section/faqs/FAQWithImage.vue'
import Component_faqs_FAQWithImage_Meta from '~/components/section/faqs/FAQWithImage.vue?builder=true'
import Component_footer_lifeboostFooter from '~/components/section/footer/lifeboostFooter.vue'
import Component_footer_lifeboostFooter_Meta from '~/components/section/footer/lifeboostFooter.vue?builder=true'
import Component_footer_salesBasicBg from '~/components/section/footer/salesBasicBg.vue'
import Component_footer_salesBasicBg_Meta from '~/components/section/footer/salesBasicBg.vue?builder=true'
import Component_footer_simpleFooter from '~/components/section/footer/simpleFooter.vue'
import Component_footer_simpleFooter_Meta from '~/components/section/footer/simpleFooter.vue?builder=true'
import Component_forms_ContentWithForm from '~/components/section/forms/ContentWithForm.vue'
import Component_forms_ContentWithForm_Meta from '~/components/section/forms/ContentWithForm.vue?builder=true'
import Component_frostedCookieBuilder_Footer from '~/components/section/frostedCookieBuilder/Footer.vue'
import Component_frostedCookieBuilder_Footer_Meta from '~/components/section/frostedCookieBuilder/Footer.vue?builder=true'
import Component_frostedCookieBuilder_SwatchesType3 from '~/components/section/frostedCookieBuilder/SwatchesType3.vue'
import Component_frostedCookieBuilder_SwatchesType3_Meta from '~/components/section/frostedCookieBuilder/SwatchesType3.vue?builder=true'
import Component_header_banner from '~/components/section/header/banner.vue'
import Component_header_banner_Meta from '~/components/section/header/banner.vue?builder=true'
import Component_header_basic from '~/components/section/header/basic.vue'
import Component_header_basic_Meta from '~/components/section/header/basic.vue?builder=true'
import Component_healthyCoffee1_AllPeople from '~/components/section/healthyCoffee1/AllPeople.vue'
import Component_healthyCoffee1_AllPeople_Meta from '~/components/section/healthyCoffee1/AllPeople.vue?builder=true'
import Component_healthyCoffee1_BannerDiscount from '~/components/section/healthyCoffee1/BannerDiscount.vue'
import Component_healthyCoffee1_BannerDiscount_Meta from '~/components/section/healthyCoffee1/BannerDiscount.vue?builder=true'
import Component_healthyCoffee1_ButtonTest from '~/components/section/healthyCoffee1/ButtonTest.vue'
import Component_healthyCoffee1_ButtonTest_Meta from '~/components/section/healthyCoffee1/ButtonTest.vue?builder=true'
import Component_healthyCoffee1_Comment from '~/components/section/healthyCoffee1/Comment.vue'
import Component_healthyCoffee1_Comment_Meta from '~/components/section/healthyCoffee1/Comment.vue?builder=true'
import Component_healthyCoffee1_DrinkCoffee from '~/components/section/healthyCoffee1/DrinkCoffee.vue'
import Component_healthyCoffee1_DrinkCoffee_Meta from '~/components/section/healthyCoffee1/DrinkCoffee.vue?builder=true'
import Component_healthyCoffee1_Footer from '~/components/section/healthyCoffee1/Footer.vue'
import Component_healthyCoffee1_Footer_Meta from '~/components/section/healthyCoffee1/Footer.vue?builder=true'
import Component_healthyCoffee1_FounderLifeBoost from '~/components/section/healthyCoffee1/FounderLifeBoost.vue'
import Component_healthyCoffee1_FounderLifeBoost_Meta from '~/components/section/healthyCoffee1/FounderLifeBoost.vue?builder=true'
import Component_healthyCoffee1_FreeShiping from '~/components/section/healthyCoffee1/FreeShiping.vue'
import Component_healthyCoffee1_FreeShiping_Meta from '~/components/section/healthyCoffee1/FreeShiping.vue?builder=true'
import Component_healthyCoffee1_FreeShipingImages from '~/components/section/healthyCoffee1/FreeShipingImages.vue'
import Component_healthyCoffee1_FreeShipingImages_Meta from '~/components/section/healthyCoffee1/FreeShipingImages.vue?builder=true'
import Component_healthyCoffee1_FromDesk from '~/components/section/healthyCoffee1/FromDesk.vue'
import Component_healthyCoffee1_FromDesk_Meta from '~/components/section/healthyCoffee1/FromDesk.vue?builder=true'
import Component_healthyCoffee1_FromMyHouse_2 from '~/components/section/healthyCoffee1/FromMyHouse-2.vue'
import Component_healthyCoffee1_FromMyHouse_2_Meta from '~/components/section/healthyCoffee1/FromMyHouse-2.vue?builder=true'
import Component_healthyCoffee1_FromMyHouse from '~/components/section/healthyCoffee1/FromMyHouse.vue'
import Component_healthyCoffee1_FromMyHouse_Meta from '~/components/section/healthyCoffee1/FromMyHouse.vue?builder=true'
import Component_healthyCoffee1_Generation_2 from '~/components/section/healthyCoffee1/Generation-2.vue'
import Component_healthyCoffee1_Generation_2_Meta from '~/components/section/healthyCoffee1/Generation-2.vue?builder=true'
import Component_healthyCoffee1_Generation from '~/components/section/healthyCoffee1/Generation.vue'
import Component_healthyCoffee1_Generation_Meta from '~/components/section/healthyCoffee1/Generation.vue?builder=true'
import Component_healthyCoffee1_Header from '~/components/section/healthyCoffee1/Header.vue'
import Component_healthyCoffee1_Header_Meta from '~/components/section/healthyCoffee1/Header.vue?builder=true'
import Component_healthyCoffee1_Hero from '~/components/section/healthyCoffee1/Hero.vue'
import Component_healthyCoffee1_Hero_Meta from '~/components/section/healthyCoffee1/Hero.vue?builder=true'
import Component_healthyCoffee1_Influencers from '~/components/section/healthyCoffee1/Influencers.vue'
import Component_healthyCoffee1_Influencers_Meta from '~/components/section/healthyCoffee1/Influencers.vue?builder=true'
import Component_healthyCoffee1_LifeBoostIncludes_2 from '~/components/section/healthyCoffee1/LifeBoostIncludes-2.vue'
import Component_healthyCoffee1_LifeBoostIncludes_2_Meta from '~/components/section/healthyCoffee1/LifeBoostIncludes-2.vue?builder=true'
import Component_healthyCoffee1_LifeBoostIncludes from '~/components/section/healthyCoffee1/LifeBoostIncludes.vue'
import Component_healthyCoffee1_LifeBoostIncludes_Meta from '~/components/section/healthyCoffee1/LifeBoostIncludes.vue?builder=true'
import Component_healthyCoffee1_PeopleHaveToSay from '~/components/section/healthyCoffee1/PeopleHaveToSay.vue'
import Component_healthyCoffee1_PeopleHaveToSay_Meta from '~/components/section/healthyCoffee1/PeopleHaveToSay.vue?builder=true'
import Component_healthyCoffee1_Qualities from '~/components/section/healthyCoffee1/Qualities.vue'
import Component_healthyCoffee1_Qualities_Meta from '~/components/section/healthyCoffee1/Qualities.vue?builder=true'
import Component_healthyCoffee1_QualitiesMore from '~/components/section/healthyCoffee1/QualitiesMore.vue'
import Component_healthyCoffee1_QualitiesMore_Meta from '~/components/section/healthyCoffee1/QualitiesMore.vue?builder=true'
import Component_healthyCoffee1_Review_2 from '~/components/section/healthyCoffee1/Review-2.vue'
import Component_healthyCoffee1_Review_2_Meta from '~/components/section/healthyCoffee1/Review-2.vue?builder=true'
import Component_healthyCoffee1_Review from '~/components/section/healthyCoffee1/Review.vue'
import Component_healthyCoffee1_Review_Meta from '~/components/section/healthyCoffee1/Review.vue?builder=true'
import Component_healthyCoffee1_ReviewShort from '~/components/section/healthyCoffee1/ReviewShort.vue'
import Component_healthyCoffee1_ReviewShort_Meta from '~/components/section/healthyCoffee1/ReviewShort.vue?builder=true'
import Component_healthyCoffee1_SimpleImage from '~/components/section/healthyCoffee1/SimpleImage.vue'
import Component_healthyCoffee1_SimpleImage_Meta from '~/components/section/healthyCoffee1/SimpleImage.vue?builder=true'
import Component_healthyCoffee1_Swatches from '~/components/section/healthyCoffee1/Swatches.vue'
import Component_healthyCoffee1_Swatches_Meta from '~/components/section/healthyCoffee1/Swatches.vue?builder=true'
import Component_healthyCoffee1_SwatchesTest_9 from '~/components/section/healthyCoffee1/SwatchesTest-9.vue'
import Component_healthyCoffee1_SwatchesTest_9_Meta from '~/components/section/healthyCoffee1/SwatchesTest-9.vue?builder=true'
import Component_healthyCoffee1_SwatchesTest8_5 from '~/components/section/healthyCoffee1/SwatchesTest8-5.vue'
import Component_healthyCoffee1_SwatchesTest8_5_Meta from '~/components/section/healthyCoffee1/SwatchesTest8-5.vue?builder=true'
import Component_healthyCoffee1_SwatchesTest8 from '~/components/section/healthyCoffee1/SwatchesTest8.vue'
import Component_healthyCoffee1_SwatchesTest8_Meta from '~/components/section/healthyCoffee1/SwatchesTest8.vue?builder=true'
import Component_healthyCoffee1_SwatchesVariant_2 from '~/components/section/healthyCoffee1/SwatchesVariant-2.vue'
import Component_healthyCoffee1_SwatchesVariant_2_Meta from '~/components/section/healthyCoffee1/SwatchesVariant-2.vue?builder=true'
import Component_healthyCoffee1_SwatchesVariant from '~/components/section/healthyCoffee1/SwatchesVariant.vue'
import Component_healthyCoffee1_SwatchesVariant_Meta from '~/components/section/healthyCoffee1/SwatchesVariant.vue?builder=true'
import Component_healthyCoffee1_Testimonials from '~/components/section/healthyCoffee1/Testimonials.vue'
import Component_healthyCoffee1_Testimonials_Meta from '~/components/section/healthyCoffee1/Testimonials.vue?builder=true'
import Component_healthyCoffee1_TitleWithPoint from '~/components/section/healthyCoffee1/TitleWithPoint.vue'
import Component_healthyCoffee1_TitleWithPoint_Meta from '~/components/section/healthyCoffee1/TitleWithPoint.vue?builder=true'
import Component_healthyCoffee1_aboutText from '~/components/section/healthyCoffee1/aboutText.vue'
import Component_healthyCoffee1_aboutText_Meta from '~/components/section/healthyCoffee1/aboutText.vue?builder=true'
import Component_healtyCoffee22Builder_AllPeople from '~/components/section/healtyCoffee22Builder/AllPeople.vue'
import Component_healtyCoffee22Builder_AllPeople_Meta from '~/components/section/healtyCoffee22Builder/AllPeople.vue?builder=true'
import Component_healtyCoffee22Builder_AllPeopleImage from '~/components/section/healtyCoffee22Builder/AllPeopleImage.vue'
import Component_healtyCoffee22Builder_AllPeopleImage_Meta from '~/components/section/healtyCoffee22Builder/AllPeopleImage.vue?builder=true'
import Component_healtyCoffee22Builder_BackgroundImage from '~/components/section/healtyCoffee22Builder/BackgroundImage.vue'
import Component_healtyCoffee22Builder_BackgroundImage_Meta from '~/components/section/healtyCoffee22Builder/BackgroundImage.vue?builder=true'
import Component_healtyCoffee22Builder_BackgroundImageText from '~/components/section/healtyCoffee22Builder/BackgroundImageText.vue'
import Component_healtyCoffee22Builder_BackgroundImageText_Meta from '~/components/section/healtyCoffee22Builder/BackgroundImageText.vue?builder=true'
import Component_healtyCoffee22Builder_Button from '~/components/section/healtyCoffee22Builder/Button.vue'
import Component_healtyCoffee22Builder_Button_Meta from '~/components/section/healtyCoffee22Builder/Button.vue?builder=true'
import Component_healtyCoffee22Builder_ContentBottomImages from '~/components/section/healtyCoffee22Builder/ContentBottomImages.vue'
import Component_healtyCoffee22Builder_ContentBottomImages_Meta from '~/components/section/healtyCoffee22Builder/ContentBottomImages.vue?builder=true'
import Component_healtyCoffee22Builder_ContentImageLeft3 from '~/components/section/healtyCoffee22Builder/ContentImageLeft3.vue'
import Component_healtyCoffee22Builder_ContentImageLeft3_Meta from '~/components/section/healtyCoffee22Builder/ContentImageLeft3.vue?builder=true'
import Component_healtyCoffee22Builder_ContentImageRight2 from '~/components/section/healtyCoffee22Builder/ContentImageRight2.vue'
import Component_healtyCoffee22Builder_ContentImageRight2_Meta from '~/components/section/healtyCoffee22Builder/ContentImageRight2.vue?builder=true'
import Component_healtyCoffee22Builder_ContentLeftImage from '~/components/section/healtyCoffee22Builder/ContentLeftImage.vue'
import Component_healtyCoffee22Builder_ContentLeftImage_Meta from '~/components/section/healtyCoffee22Builder/ContentLeftImage.vue?builder=true'
import Component_healtyCoffee22Builder_ContentLeftimage2 from '~/components/section/healtyCoffee22Builder/ContentLeftimage2.vue'
import Component_healtyCoffee22Builder_ContentLeftimage2_Meta from '~/components/section/healtyCoffee22Builder/ContentLeftimage2.vue?builder=true'
import Component_healtyCoffee22Builder_ContentRightImage from '~/components/section/healtyCoffee22Builder/ContentRightImage.vue'
import Component_healtyCoffee22Builder_ContentRightImage_Meta from '~/components/section/healtyCoffee22Builder/ContentRightImage.vue?builder=true'
import Component_healtyCoffee22Builder_ContentSectionWithSvg from '~/components/section/healtyCoffee22Builder/ContentSectionWithSvg.vue'
import Component_healtyCoffee22Builder_ContentSectionWithSvg_Meta from '~/components/section/healtyCoffee22Builder/ContentSectionWithSvg.vue?builder=true'
import Component_healtyCoffee22Builder_ContentTextImage from '~/components/section/healtyCoffee22Builder/ContentTextImage.vue'
import Component_healtyCoffee22Builder_ContentTextImage_Meta from '~/components/section/healtyCoffee22Builder/ContentTextImage.vue?builder=true'
import Component_healtyCoffee22Builder_FromDesk2 from '~/components/section/healtyCoffee22Builder/FromDesk2.vue'
import Component_healtyCoffee22Builder_FromDesk2_Meta from '~/components/section/healtyCoffee22Builder/FromDesk2.vue?builder=true'
import Component_healtyCoffee22Builder_ImagesLine2 from '~/components/section/healtyCoffee22Builder/ImagesLine2.vue'
import Component_healtyCoffee22Builder_ImagesLine2_Meta from '~/components/section/healtyCoffee22Builder/ImagesLine2.vue?builder=true'
import Component_healtyCoffee22Builder_LogoSection from '~/components/section/healtyCoffee22Builder/LogoSection.vue'
import Component_healtyCoffee22Builder_LogoSection_Meta from '~/components/section/healtyCoffee22Builder/LogoSection.vue?builder=true'
import Component_healtyCoffee22Builder_References from '~/components/section/healtyCoffee22Builder/References.vue'
import Component_healtyCoffee22Builder_References_Meta from '~/components/section/healtyCoffee22Builder/References.vue?builder=true'
import Component_healtyCoffee22Builder_Reviews2 from '~/components/section/healtyCoffee22Builder/Reviews2.vue'
import Component_healtyCoffee22Builder_Reviews2_Meta from '~/components/section/healtyCoffee22Builder/Reviews2.vue?builder=true'
import Component_healtyCoffee22Builder_Reviews3 from '~/components/section/healtyCoffee22Builder/Reviews3.vue'
import Component_healtyCoffee22Builder_Reviews3_Meta from '~/components/section/healtyCoffee22Builder/Reviews3.vue?builder=true'
import Component_healtyCoffee22Builder_SectionWithVideo from '~/components/section/healtyCoffee22Builder/SectionWithVideo.vue'
import Component_healtyCoffee22Builder_SectionWithVideo_Meta from '~/components/section/healtyCoffee22Builder/SectionWithVideo.vue?builder=true'
import Component_healtyCoffee22Builder_SwatchesType2 from '~/components/section/healtyCoffee22Builder/SwatchesType2.vue'
import Component_healtyCoffee22Builder_SwatchesType2_Meta from '~/components/section/healtyCoffee22Builder/SwatchesType2.vue?builder=true'
import Component_healtyCoffee22Builder_benefits from '~/components/section/healtyCoffee22Builder/benefits.vue'
import Component_healtyCoffee22Builder_benefits_Meta from '~/components/section/healtyCoffee22Builder/benefits.vue?builder=true'
import Component_healtyCoffee22Builder_content from '~/components/section/healtyCoffee22Builder/content.vue'
import Component_healtyCoffee22Builder_content_Meta from '~/components/section/healtyCoffee22Builder/content.vue?builder=true'
import Component_healtyCoffee22Builder_images_line from '~/components/section/healtyCoffee22Builder/images-line.vue'
import Component_healtyCoffee22Builder_images_line_Meta from '~/components/section/healtyCoffee22Builder/images-line.vue?builder=true'
import Component_healtyCoffee22Builder_info from '~/components/section/healtyCoffee22Builder/info.vue'
import Component_healtyCoffee22Builder_info_Meta from '~/components/section/healtyCoffee22Builder/info.vue?builder=true'
import Component_hero_HeadTextCta from '~/components/section/hero/HeadTextCta.vue'
import Component_hero_HeadTextCta_Meta from '~/components/section/hero/HeadTextCta.vue?builder=true'
import Component_hero_HighlightNews from '~/components/section/hero/HighlightNews.vue'
import Component_hero_HighlightNews_Meta from '~/components/section/hero/HighlightNews.vue?builder=true'
import Component_hero_ProductHeadline from '~/components/section/hero/ProductHeadline.vue'
import Component_hero_ProductHeadline_Meta from '~/components/section/hero/ProductHeadline.vue?builder=true'
import Component_hero_ProductIntro from '~/components/section/hero/ProductIntro.vue'
import Component_hero_ProductIntro_Meta from '~/components/section/hero/ProductIntro.vue?builder=true'
import Component_hero_ProductWithShowcase from '~/components/section/hero/ProductWithShowcase.vue'
import Component_hero_ProductWithShowcase_Meta from '~/components/section/hero/ProductWithShowcase.vue?builder=true'
import Component_hero_TextInsightWithImage from '~/components/section/hero/TextInsightWithImage.vue'
import Component_hero_TextInsightWithImage_Meta from '~/components/section/hero/TextInsightWithImage.vue?builder=true'
import Component_hero_TitleDescriptionVideo from '~/components/section/hero/TitleDescriptionVideo.vue'
import Component_hero_TitleDescriptionVideo_Meta from '~/components/section/hero/TitleDescriptionVideo.vue?builder=true'
import Component_hero_TitleInfoImageCta from '~/components/section/hero/TitleInfoImageCta.vue'
import Component_hero_TitleInfoImageCta_Meta from '~/components/section/hero/TitleInfoImageCta.vue?builder=true'
import Component_hero_VideoSignup from '~/components/section/hero/VideoSignup.vue'
import Component_hero_VideoSignup_Meta from '~/components/section/hero/VideoSignup.vue?builder=true'
import Component_lifeboostLatteBuilder_ContentLefImage3 from '~/components/section/lifeboostLatteBuilder/ContentLefImage3.vue'
import Component_lifeboostLatteBuilder_ContentLefImage3_Meta from '~/components/section/lifeboostLatteBuilder/ContentLefImage3.vue?builder=true'
import Component_lifeboostLatteBuilder_DescriptionImageList from '~/components/section/lifeboostLatteBuilder/DescriptionImageList.vue'
import Component_lifeboostLatteBuilder_DescriptionImageList_Meta from '~/components/section/lifeboostLatteBuilder/DescriptionImageList.vue?builder=true'
import Component_lifeboostLatteBuilder_DescriptionWithListPricing from '~/components/section/lifeboostLatteBuilder/DescriptionWithListPricing.vue'
import Component_lifeboostLatteBuilder_DescriptionWithListPricing_Meta from '~/components/section/lifeboostLatteBuilder/DescriptionWithListPricing.vue?builder=true'
import Component_lifeboostLatteBuilder_FDA from '~/components/section/lifeboostLatteBuilder/FDA.vue'
import Component_lifeboostLatteBuilder_FDA_Meta from '~/components/section/lifeboostLatteBuilder/FDA.vue?builder=true'
import Component_lifeboostLatteBuilder_Footer from '~/components/section/lifeboostLatteBuilder/Footer.vue'
import Component_lifeboostLatteBuilder_Footer_Meta from '~/components/section/lifeboostLatteBuilder/Footer.vue?builder=true'
import Component_lifeboostLatteBuilder_HeadingCTAButton from '~/components/section/lifeboostLatteBuilder/HeadingCTAButton.vue'
import Component_lifeboostLatteBuilder_HeadingCTAButton_Meta from '~/components/section/lifeboostLatteBuilder/HeadingCTAButton.vue?builder=true'
import Component_lifeboostLatteBuilder_Hero from '~/components/section/lifeboostLatteBuilder/Hero.vue'
import Component_lifeboostLatteBuilder_Hero_Meta from '~/components/section/lifeboostLatteBuilder/Hero.vue?builder=true'
import Component_lifeboostLatteBuilder_HomeSteps from '~/components/section/lifeboostLatteBuilder/HomeSteps.vue'
import Component_lifeboostLatteBuilder_HomeSteps_Meta from '~/components/section/lifeboostLatteBuilder/HomeSteps.vue?builder=true'
import Component_lifeboostLatteBuilder_Reviews4 from '~/components/section/lifeboostLatteBuilder/Reviews4.vue'
import Component_lifeboostLatteBuilder_Reviews4_Meta from '~/components/section/lifeboostLatteBuilder/Reviews4.vue?builder=true'
import Component_lifeboostLatteBuilder_TestimonialSwiper from '~/components/section/lifeboostLatteBuilder/TestimonialSwiper.vue'
import Component_lifeboostLatteBuilder_TestimonialSwiper_Meta from '~/components/section/lifeboostLatteBuilder/TestimonialSwiper.vue?builder=true'
import Component_lifeboostLatteBuilder_TextWithVideo from '~/components/section/lifeboostLatteBuilder/TextWithVideo.vue'
import Component_lifeboostLatteBuilder_TextWithVideo_Meta from '~/components/section/lifeboostLatteBuilder/TextWithVideo.vue?builder=true'
import Component_lists_InfoListWithSources from '~/components/section/lists/InfoListWithSources.vue'
import Component_lists_InfoListWithSources_Meta from '~/components/section/lists/InfoListWithSources.vue?builder=true'
import Component_logos_ListFlex from '~/components/section/logos/ListFlex.vue'
import Component_logos_ListFlex_Meta from '~/components/section/logos/ListFlex.vue?builder=true'
import Component_mushroomBuilder_BackgroundTitleListImages from '~/components/section/mushroomBuilder/BackgroundTitleListImages.vue'
import Component_mushroomBuilder_BackgroundTitleListImages_Meta from '~/components/section/mushroomBuilder/BackgroundTitleListImages.vue?builder=true'
import Component_mushroomBuilder_BasicSwatches from '~/components/section/mushroomBuilder/BasicSwatches.vue'
import Component_mushroomBuilder_BasicSwatches_Meta from '~/components/section/mushroomBuilder/BasicSwatches.vue?builder=true'
import Component_mushroomBuilder_CoffeeGuarantee from '~/components/section/mushroomBuilder/CoffeeGuarantee.vue'
import Component_mushroomBuilder_CoffeeGuarantee_Meta from '~/components/section/mushroomBuilder/CoffeeGuarantee.vue?builder=true'
import Component_mushroomBuilder_ContentWithRoundedIcons from '~/components/section/mushroomBuilder/ContentWithRoundedIcons.vue'
import Component_mushroomBuilder_ContentWithRoundedIcons_Meta from '~/components/section/mushroomBuilder/ContentWithRoundedIcons.vue?builder=true'
import Component_mushroomBuilder_FrequentlyQuestionsTwoColumns from '~/components/section/mushroomBuilder/FrequentlyQuestionsTwoColumns.vue'
import Component_mushroomBuilder_FrequentlyQuestionsTwoColumns_Meta from '~/components/section/mushroomBuilder/FrequentlyQuestionsTwoColumns.vue?builder=true'
import Component_mushroomBuilder_Header from '~/components/section/mushroomBuilder/Header.vue'
import Component_mushroomBuilder_Header_Meta from '~/components/section/mushroomBuilder/Header.vue?builder=true'
import Component_mushroomBuilder_Hero from '~/components/section/mushroomBuilder/Hero.vue'
import Component_mushroomBuilder_Hero_Meta from '~/components/section/mushroomBuilder/Hero.vue?builder=true'
import Component_mushroomBuilder_ImageFeatureList from '~/components/section/mushroomBuilder/ImageFeatureList.vue'
import Component_mushroomBuilder_ImageFeatureList_Meta from '~/components/section/mushroomBuilder/ImageFeatureList.vue?builder=true'
import Component_mushroomBuilder_ReviewWithTitle from '~/components/section/mushroomBuilder/ReviewWithTitle.vue'
import Component_mushroomBuilder_ReviewWithTitle_Meta from '~/components/section/mushroomBuilder/ReviewWithTitle.vue?builder=true'
import Component_mushroomBuilder_TableCompare from '~/components/section/mushroomBuilder/TableCompare.vue'
import Component_mushroomBuilder_TableCompare_Meta from '~/components/section/mushroomBuilder/TableCompare.vue?builder=true'
import Component_mushroomNewBuilder_Banner from '~/components/section/mushroomNewBuilder/Banner.vue'
import Component_mushroomNewBuilder_Banner_Meta from '~/components/section/mushroomNewBuilder/Banner.vue?builder=true'
import Component_mushroomNewBuilder_ContentWithLeftImages from '~/components/section/mushroomNewBuilder/ContentWithLeftImages.vue'
import Component_mushroomNewBuilder_ContentWithLeftImages_Meta from '~/components/section/mushroomNewBuilder/ContentWithLeftImages.vue?builder=true'
import Component_mushroomNewBuilder_DescriptionWithIcons from '~/components/section/mushroomNewBuilder/DescriptionWithIcons.vue'
import Component_mushroomNewBuilder_DescriptionWithIcons_Meta from '~/components/section/mushroomNewBuilder/DescriptionWithIcons.vue?builder=true'
import Component_mushroomNewBuilder_Footer from '~/components/section/mushroomNewBuilder/Footer.vue'
import Component_mushroomNewBuilder_Footer_Meta from '~/components/section/mushroomNewBuilder/Footer.vue?builder=true'
import Component_mushroomNewBuilder_FrequentlyQuestions from '~/components/section/mushroomNewBuilder/FrequentlyQuestions.vue'
import Component_mushroomNewBuilder_FrequentlyQuestions_Meta from '~/components/section/mushroomNewBuilder/FrequentlyQuestions.vue?builder=true'
import Component_mushroomNewBuilder_Header from '~/components/section/mushroomNewBuilder/Header.vue'
import Component_mushroomNewBuilder_Header_Meta from '~/components/section/mushroomNewBuilder/Header.vue?builder=true'
import Component_mushroomNewBuilder_Hero from '~/components/section/mushroomNewBuilder/Hero.vue'
import Component_mushroomNewBuilder_Hero_Meta from '~/components/section/mushroomNewBuilder/Hero.vue?builder=true'
import Component_mushroomNewBuilder_IconsWithImagesSwiper from '~/components/section/mushroomNewBuilder/IconsWithImagesSwiper.vue'
import Component_mushroomNewBuilder_IconsWithImagesSwiper_Meta from '~/components/section/mushroomNewBuilder/IconsWithImagesSwiper.vue?builder=true'
import Component_mushroomNewBuilder_ImageReviews from '~/components/section/mushroomNewBuilder/ImageReviews.vue'
import Component_mushroomNewBuilder_ImageReviews_Meta from '~/components/section/mushroomNewBuilder/ImageReviews.vue?builder=true'
import Component_mushroomNewBuilder_LogoSwiper from '~/components/section/mushroomNewBuilder/LogoSwiper.vue'
import Component_mushroomNewBuilder_LogoSwiper_Meta from '~/components/section/mushroomNewBuilder/LogoSwiper.vue?builder=true'
import Component_mushroomNewBuilder_OptionsProductsWithUpsell from '~/components/section/mushroomNewBuilder/OptionsProductsWithUpsell.vue'
import Component_mushroomNewBuilder_OptionsProductsWithUpsell_Meta from '~/components/section/mushroomNewBuilder/OptionsProductsWithUpsell.vue?builder=true'
import Component_mushroomNewBuilder_RaitingStars from '~/components/section/mushroomNewBuilder/RaitingStars.vue'
import Component_mushroomNewBuilder_RaitingStars_Meta from '~/components/section/mushroomNewBuilder/RaitingStars.vue?builder=true'
import Component_mushroomNewBuilder_Reviews from '~/components/section/mushroomNewBuilder/Reviews.vue'
import Component_mushroomNewBuilder_Reviews_Meta from '~/components/section/mushroomNewBuilder/Reviews.vue?builder=true'
import Component_mushroomNewBuilder_SaleBanner from '~/components/section/mushroomNewBuilder/SaleBanner.vue'
import Component_mushroomNewBuilder_SaleBanner_Meta from '~/components/section/mushroomNewBuilder/SaleBanner.vue?builder=true'
import Component_mushroomNewBuilder_TableWithCheckbox from '~/components/section/mushroomNewBuilder/TableWithCheckbox.vue'
import Component_mushroomNewBuilder_TableWithCheckbox_Meta from '~/components/section/mushroomNewBuilder/TableWithCheckbox.vue?builder=true'
import Component_mushroomNewBuilder_Testimonial from '~/components/section/mushroomNewBuilder/Testimonial.vue'
import Component_mushroomNewBuilder_Testimonial_Meta from '~/components/section/mushroomNewBuilder/Testimonial.vue?builder=true'
import Component_mushroomNewBuilder_TitleDescriptionIcons from '~/components/section/mushroomNewBuilder/TitleDescriptionIcons.vue'
import Component_mushroomNewBuilder_TitleDescriptionIcons_Meta from '~/components/section/mushroomNewBuilder/TitleDescriptionIcons.vue?builder=true'
import Component_mushroomNewBuilder_TitleDescriptionsPrice from '~/components/section/mushroomNewBuilder/TitleDescriptionsPrice.vue'
import Component_mushroomNewBuilder_TitleDescriptionsPrice_Meta from '~/components/section/mushroomNewBuilder/TitleDescriptionsPrice.vue?builder=true'
import Component_mushroomNewBuilder_TitleDescriptionsPriceDup from '~/components/section/mushroomNewBuilder/TitleDescriptionsPriceDup.vue'
import Component_mushroomNewBuilder_TitleDescriptionsPriceDup_Meta from '~/components/section/mushroomNewBuilder/TitleDescriptionsPriceDup.vue?builder=true'
import Component_mushroomNewBuilder_Verified from '~/components/section/mushroomNewBuilder/Verified.vue'
import Component_mushroomNewBuilder_Verified_Meta from '~/components/section/mushroomNewBuilder/Verified.vue?builder=true'
import Component_mushroomSpecial_TitleDescriptionsPrice from '~/components/section/mushroomSpecial/TitleDescriptionsPrice.vue'
import Component_mushroomSpecial_TitleDescriptionsPrice_Meta from '~/components/section/mushroomSpecial/TitleDescriptionsPrice.vue?builder=true'
import Component_overlay_SubscriptionOverlay from '~/components/section/overlay/SubscriptionOverlay.vue'
import Component_overlay_SubscriptionOverlay_Meta from '~/components/section/overlay/SubscriptionOverlay.vue?builder=true'
import Component_rating_starsRating from '~/components/section/rating/starsRating.vue'
import Component_rating_starsRating_Meta from '~/components/section/rating/starsRating.vue?builder=true'
import Component_reviews_ReviewProduct from '~/components/section/reviews/ReviewProduct.vue'
import Component_reviews_ReviewProduct_Meta from '~/components/section/reviews/ReviewProduct.vue?builder=true'
import Component_reviews_ReviewWithComments from '~/components/section/reviews/ReviewWithComments.vue'
import Component_reviews_ReviewWithComments_Meta from '~/components/section/reviews/ReviewWithComments.vue?builder=true'
import Component_sipsBuilder_BoxSeason from '~/components/section/sipsBuilder/BoxSeason.vue'
import Component_sipsBuilder_BoxSeason_Meta from '~/components/section/sipsBuilder/BoxSeason.vue?builder=true'
import Component_sipsBuilder_BoxSixCustomCuratedFlavors from '~/components/section/sipsBuilder/BoxSixCustomCuratedFlavors.vue'
import Component_sipsBuilder_BoxSixCustomCuratedFlavors_Meta from '~/components/section/sipsBuilder/BoxSixCustomCuratedFlavors.vue?builder=true'
import Component_sipsBuilder_Footer1 from '~/components/section/sipsBuilder/Footer1.vue'
import Component_sipsBuilder_Footer1_Meta from '~/components/section/sipsBuilder/Footer1.vue?builder=true'
import Component_sipsBuilder_HowItWorks from '~/components/section/sipsBuilder/HowItWorks.vue'
import Component_sipsBuilder_HowItWorks_Meta from '~/components/section/sipsBuilder/HowItWorks.vue?builder=true'
import Component_sipsBuilder_Questions from '~/components/section/sipsBuilder/Questions.vue'
import Component_sipsBuilder_Questions_Meta from '~/components/section/sipsBuilder/Questions.vue?builder=true'
import Component_sipsBuilder_Reviews from '~/components/section/sipsBuilder/Reviews.vue'
import Component_sipsBuilder_Reviews_Meta from '~/components/section/sipsBuilder/Reviews.vue?builder=true'
import Component_sipsBuilder_Schedule from '~/components/section/sipsBuilder/Schedule.vue'
import Component_sipsBuilder_Schedule_Meta from '~/components/section/sipsBuilder/Schedule.vue?builder=true'
import Component_sipsBuilder_SeasonalSipsClub from '~/components/section/sipsBuilder/SeasonalSipsClub.vue'
import Component_sipsBuilder_SeasonalSipsClub_Meta from '~/components/section/sipsBuilder/SeasonalSipsClub.vue?builder=true'
import Component_sipsBuilder_WhyChooseLifeboost from '~/components/section/sipsBuilder/WhyChooseLifeboost.vue'
import Component_sipsBuilder_WhyChooseLifeboost_Meta from '~/components/section/sipsBuilder/WhyChooseLifeboost.vue?builder=true'
import Component_strawberry_Content_video from '~/components/section/strawberry/Content_video.vue'
import Component_strawberry_Content_video_Meta from '~/components/section/strawberry/Content_video.vue?builder=true'
import Component_swatches_Subscription from '~/components/section/swatches/Subscription.vue'
import Component_swatches_Subscription_Meta from '~/components/section/swatches/Subscription.vue?builder=true'
import Component_swatches_SwatchesWithSwiper from '~/components/section/swatches/SwatchesWithSwiper.vue'
import Component_swatches_SwatchesWithSwiper_Meta from '~/components/section/swatches/SwatchesWithSwiper.vue?builder=true'
import Component_testimonials_CardGrid from '~/components/section/testimonials/CardGrid.vue'
import Component_testimonials_CardGrid_Meta from '~/components/section/testimonials/CardGrid.vue?builder=true'
import Component_testimonials_CardGridShadow from '~/components/section/testimonials/CardGridShadow.vue'
import Component_testimonials_CardGridShadow_Meta from '~/components/section/testimonials/CardGridShadow.vue?builder=true'
import Component_testimonials_ImageReviews from '~/components/section/testimonials/ImageReviews.vue'
import Component_testimonials_ImageReviews_Meta from '~/components/section/testimonials/ImageReviews.vue?builder=true'
import Component_testimonials_ListImageInfo from '~/components/section/testimonials/ListImageInfo.vue'
import Component_testimonials_ListImageInfo_Meta from '~/components/section/testimonials/ListImageInfo.vue?builder=true'
import Component_testimonials_ListImageInfoRight from '~/components/section/testimonials/ListImageInfoRight.vue'
import Component_testimonials_ListImageInfoRight_Meta from '~/components/section/testimonials/ListImageInfoRight.vue?builder=true'
import Component_testimonials_ListInfoLeft from '~/components/section/testimonials/ListInfoLeft.vue'
import Component_testimonials_ListInfoLeft_Meta from '~/components/section/testimonials/ListInfoLeft.vue?builder=true'
import Component_testimonials_ListWithText from '~/components/section/testimonials/ListWithText.vue'
import Component_testimonials_ListWithText_Meta from '~/components/section/testimonials/ListWithText.vue?builder=true'
import Component_testimonials_ListWithTextCta from '~/components/section/testimonials/ListWithTextCta.vue'
import Component_testimonials_ListWithTextCta_Meta from '~/components/section/testimonials/ListWithTextCta.vue?builder=true'
import Component_testimonials_ReviewGrid from '~/components/section/testimonials/ReviewGrid.vue'
import Component_testimonials_ReviewGrid_Meta from '~/components/section/testimonials/ReviewGrid.vue?builder=true'
import Component_textBlocks_HeadingImageWithText from '~/components/section/textBlocks/HeadingImageWithText.vue'
import Component_textBlocks_HeadingImageWithText_Meta from '~/components/section/textBlocks/HeadingImageWithText.vue?builder=true'
import Component_textBlocks_HeadingWhitText from '~/components/section/textBlocks/HeadingWhitText.vue'
import Component_textBlocks_HeadingWhitText_Meta from '~/components/section/textBlocks/HeadingWhitText.vue?builder=true'
import Component_tickers_AlertsAnimations from '~/components/section/tickers/AlertsAnimations.vue'
import Component_tickers_AlertsAnimations_Meta from '~/components/section/tickers/AlertsAnimations.vue?builder=true'
import Component_zipifyBuilder_BackgroundImageWithCheckList from '~/components/section/zipifyBuilder/BackgroundImageWithCheckList.vue'
import Component_zipifyBuilder_BackgroundImageWithCheckList_Meta from '~/components/section/zipifyBuilder/BackgroundImageWithCheckList.vue?builder=true'
import Component_zipifyBuilder_BgTexImage from '~/components/section/zipifyBuilder/BgTexImage.vue'
import Component_zipifyBuilder_BgTexImage_Meta from '~/components/section/zipifyBuilder/BgTexImage.vue?builder=true'
import Component_zipifyBuilder_ContentWithLeftImage from '~/components/section/zipifyBuilder/ContentWithLeftImage.vue'
import Component_zipifyBuilder_ContentWithLeftImage_Meta from '~/components/section/zipifyBuilder/ContentWithLeftImage.vue?builder=true'
import Component_zipifyBuilder_DescriptionLeftRightImage from '~/components/section/zipifyBuilder/DescriptionLeftRightImage.vue'
import Component_zipifyBuilder_DescriptionLeftRightImage_Meta from '~/components/section/zipifyBuilder/DescriptionLeftRightImage.vue?builder=true'
import Component_zipifyBuilder_DescriptionListWithImage from '~/components/section/zipifyBuilder/DescriptionListWithImage.vue'
import Component_zipifyBuilder_DescriptionListWithImage_Meta from '~/components/section/zipifyBuilder/DescriptionListWithImage.vue?builder=true'
import Component_zipifyBuilder_Header from '~/components/section/zipifyBuilder/Header.vue'
import Component_zipifyBuilder_Header_Meta from '~/components/section/zipifyBuilder/Header.vue?builder=true'
import Component_zipifyBuilder_HeroBackgroundAndImage from '~/components/section/zipifyBuilder/HeroBackgroundAndImage.vue'
import Component_zipifyBuilder_HeroBackgroundAndImage_Meta from '~/components/section/zipifyBuilder/HeroBackgroundAndImage.vue?builder=true'
import Component_zipifyBuilder_HeroWithBackground from '~/components/section/zipifyBuilder/HeroWithBackground.vue'
import Component_zipifyBuilder_HeroWithBackground_Meta from '~/components/section/zipifyBuilder/HeroWithBackground.vue?builder=true'
import Component_zipifyBuilder_ImageWhitQuote from '~/components/section/zipifyBuilder/ImageWhitQuote.vue'
import Component_zipifyBuilder_ImageWhitQuote_Meta from '~/components/section/zipifyBuilder/ImageWhitQuote.vue?builder=true'
import Component_zipifyBuilder_ImageWithIconsList from '~/components/section/zipifyBuilder/ImageWithIconsList.vue'
import Component_zipifyBuilder_ImageWithIconsList_Meta from '~/components/section/zipifyBuilder/ImageWithIconsList.vue?builder=true'
import Component_zipifyBuilder_LongTextWithImages from '~/components/section/zipifyBuilder/LongTextWithImages.vue'
import Component_zipifyBuilder_LongTextWithImages_Meta from '~/components/section/zipifyBuilder/LongTextWithImages.vue?builder=true'
import Component_zipifyBuilder_ProductHighlightsAndRecognition from '~/components/section/zipifyBuilder/ProductHighlightsAndRecognition.vue'
import Component_zipifyBuilder_ProductHighlightsAndRecognition_Meta from '~/components/section/zipifyBuilder/ProductHighlightsAndRecognition.vue?builder=true'
import Component_zipifyBuilder_Swatches from '~/components/section/zipifyBuilder/Swatches.vue'
import Component_zipifyBuilder_Swatches_Meta from '~/components/section/zipifyBuilder/Swatches.vue?builder=true'
import Component_zipifyBuilder_TestimonialsWithOptionsColors from '~/components/section/zipifyBuilder/TestimonialsWithOptionsColors.vue'
import Component_zipifyBuilder_TestimonialsWithOptionsColors_Meta from '~/components/section/zipifyBuilder/TestimonialsWithOptionsColors.vue?builder=true'
import Component_zipifyBuilder_TitleWithImageCTA from '~/components/section/zipifyBuilder/TitleWithImageCTA.vue'
import Component_zipifyBuilder_TitleWithImageCTA_Meta from '~/components/section/zipifyBuilder/TitleWithImageCTA.vue?builder=true'

const allComponents = [
  {
    name: 'SwiperProductCallery',
    friendlyName: 'SwiperProductGallery',
    component: Component_SwiperProductCallery,
    metadata: Component_SwiperProductCallery_Meta && Component_SwiperProductCallery_Meta.default ? Component_SwiperProductCallery_Meta.default : { friendlyName: 'SwiperProductGallery' }
  },
  {
    name: 'TextDescriptionBgHead',
    friendlyName: 'Text Description with Badge',
    component: Component_badge_TextDescriptionBgHead,
    metadata: Component_badge_TextDescriptionBgHead_Meta && Component_badge_TextDescriptionBgHead_Meta.default ? Component_badge_TextDescriptionBgHead_Meta.default : { friendlyName: 'Text Description with Badge' }
  },
  {
    name: 'CountdownBanner',
    friendlyName: 'CountdownBanner',
    component: Component_banner_CountdownBanner,
    metadata: Component_banner_CountdownBanner_Meta && Component_banner_CountdownBanner_Meta.default ? Component_banner_CountdownBanner_Meta.default : { friendlyName: 'CountdownBanner' }
  },
  {
    name: 'RatingWithText',
    friendlyName: 'Banner - Rating With Text',
    component: Component_banner_RatingWithText,
    metadata: Component_banner_RatingWithText_Meta && Component_banner_RatingWithText_Meta.default ? Component_banner_RatingWithText_Meta.default : { friendlyName: 'Banner - Rating With Text' }
  },
  {
    name: 'PromoBundle',
    friendlyName: 'PromoBundle',
    component: Component_bonus_PromoBundle,
    metadata: Component_bonus_PromoBundle_Meta && Component_bonus_PromoBundle_Meta.default ? Component_bonus_PromoBundle_Meta.default : { friendlyName: 'PromoBundle' }
  },
  {
    name: 'SavingCalculator',
    friendlyName: 'ChartSavingCalculator',
    component: Component_charts_SavingCalculator,
    metadata: Component_charts_SavingCalculator_Meta && Component_charts_SavingCalculator_Meta.default ? Component_charts_SavingCalculator_Meta.default : { friendlyName: 'ChartSavingCalculator' }
  },
  {
    name: 'BackgroundTextImage',
    friendlyName: 'Background Text Image',
    component: Component_content_BackgroundTextImage,
    metadata: Component_content_BackgroundTextImage_Meta && Component_content_BackgroundTextImage_Meta.default ? Component_content_BackgroundTextImage_Meta.default : { friendlyName: 'Background Text Image' }
  },
  {
    name: 'BenefitsShowcase',
    friendlyName: 'BenefitsShowcase',
    component: Component_content_BenefitsShowcase,
    metadata: Component_content_BenefitsShowcase_Meta && Component_content_BenefitsShowcase_Meta.default ? Component_content_BenefitsShowcase_Meta.default : { friendlyName: 'BenefitsShowcase' }
  },
  {
    name: 'BundleOfferShowcase',
    friendlyName: 'Bundle Offer Showcase',
    component: Component_content_BundleOfferShowcase,
    metadata: Component_content_BundleOfferShowcase_Meta && Component_content_BundleOfferShowcase_Meta.default ? Component_content_BundleOfferShowcase_Meta.default : { friendlyName: 'Bundle Offer Showcase' }
  },
  {
    name: 'ContentShowcase',
    friendlyName: 'Content Showcase',
    component: Component_content_ContentShowcase,
    metadata: Component_content_ContentShowcase_Meta && Component_content_ContentShowcase_Meta.default ? Component_content_ContentShowcase_Meta.default : { friendlyName: 'Content Showcase' }
  },
  {
    name: 'DecisionOptionsWithCTA',
    friendlyName: 'Decision Options with CTA',
    component: Component_content_DecisionOptionsWithCTA,
    metadata: Component_content_DecisionOptionsWithCTA_Meta && Component_content_DecisionOptionsWithCTA_Meta.default ? Component_content_DecisionOptionsWithCTA_Meta.default : { friendlyName: 'Decision Options with CTA' }
  },
  {
    name: 'DescriptionCtaImage',
    friendlyName: 'Content - Description CTA Image',
    component: Component_content_DescriptionCtaImage,
    metadata: Component_content_DescriptionCtaImage_Meta && Component_content_DescriptionCtaImage_Meta.default ? Component_content_DescriptionCtaImage_Meta.default : { friendlyName: 'Content - Description CTA Image' }
  },
  {
    name: 'ExpertInsight',
    friendlyName: 'Expert Insight Section',
    component: Component_content_ExpertInsight,
    metadata: Component_content_ExpertInsight_Meta && Component_content_ExpertInsight_Meta.default ? Component_content_ExpertInsight_Meta.default : { friendlyName: 'Expert Insight Section' }
  },
  {
    name: 'FeatureHighlightButtons',
    friendlyName: 'FeatureHighlightButtons',
    component: Component_content_FeatureHighlightButtons,
    metadata: Component_content_FeatureHighlightButtons_Meta && Component_content_FeatureHighlightButtons_Meta.default ? Component_content_FeatureHighlightButtons_Meta.default : { friendlyName: 'FeatureHighlightButtons' }
  },
  {
    name: 'FeatureIconsWithImage',
    friendlyName: 'Feature Icons With Image',
    component: Component_content_FeatureIconsWithImage,
    metadata: Component_content_FeatureIconsWithImage_Meta && Component_content_FeatureIconsWithImage_Meta.default ? Component_content_FeatureIconsWithImage_Meta.default : { friendlyName: 'Feature Icons With Image' }
  },
  {
    name: 'FeatureInfoIconsImage',
    friendlyName: 'FeatureInfoIconsImage',
    component: Component_content_FeatureInfoIconsImage,
    metadata: Component_content_FeatureInfoIconsImage_Meta && Component_content_FeatureInfoIconsImage_Meta.default ? Component_content_FeatureInfoIconsImage_Meta.default : { friendlyName: 'FeatureInfoIconsImage' }
  },
  {
    name: 'FeatureWithIconsAndCTA',
    friendlyName: 'FeatureWithIconsAndCTA',
    component: Component_content_FeatureWithIconsAndCTA,
    metadata: Component_content_FeatureWithIconsAndCTA_Meta && Component_content_FeatureWithIconsAndCTA_Meta.default ? Component_content_FeatureWithIconsAndCTA_Meta.default : { friendlyName: 'FeatureWithIconsAndCTA' }
  },
  {
    name: 'FeatureWithIconsAndImage',
    friendlyName: 'FeatureWithIconsAndImage',
    component: Component_content_FeatureWithIconsAndImage,
    metadata: Component_content_FeatureWithIconsAndImage_Meta && Component_content_FeatureWithIconsAndImage_Meta.default ? Component_content_FeatureWithIconsAndImage_Meta.default : { friendlyName: 'FeatureWithIconsAndImage' }
  },
  {
    name: 'FeatureWithImage',
    friendlyName: 'FeatureWithImage',
    component: Component_content_FeatureWithImage,
    metadata: Component_content_FeatureWithImage_Meta && Component_content_FeatureWithImage_Meta.default ? Component_content_FeatureWithImage_Meta.default : { friendlyName: 'FeatureWithImage' }
  },
  {
    name: 'FeatureWithImageAndBenefits',
    friendlyName: 'FeatureWithImageAndBenefits',
    component: Component_content_FeatureWithImageAndBenefits,
    metadata: Component_content_FeatureWithImageAndBenefits_Meta && Component_content_FeatureWithImageAndBenefits_Meta.default ? Component_content_FeatureWithImageAndBenefits_Meta.default : { friendlyName: 'FeatureWithImageAndBenefits' }
  },
  {
    name: 'FeatureWithImageAndIcons',
    friendlyName: 'FeatureWithImageAndIcons',
    component: Component_content_FeatureWithImageAndIcons,
    metadata: Component_content_FeatureWithImageAndIcons_Meta && Component_content_FeatureWithImageAndIcons_Meta.default ? Component_content_FeatureWithImageAndIcons_Meta.default : { friendlyName: 'FeatureWithImageAndIcons' }
  },
  {
    name: 'GridFeatureIconsWithImage',
    friendlyName: 'Grid Feature Icons With Image',
    component: Component_content_GridFeatureIconsWithImage,
    metadata: Component_content_GridFeatureIconsWithImage_Meta && Component_content_GridFeatureIconsWithImage_Meta.default ? Component_content_GridFeatureIconsWithImage_Meta.default : { friendlyName: 'Grid Feature Icons With Image' }
  },
  {
    name: 'GridItemsButton',
    friendlyName: 'GridItemsButton',
    component: Component_content_GridItemsButton,
    metadata: Component_content_GridItemsButton_Meta && Component_content_GridItemsButton_Meta.default ? Component_content_GridItemsButton_Meta.default : { friendlyName: 'GridItemsButton' }
  },
  {
    name: 'HeadlineWithIconList',
    friendlyName: 'Headline With Icon List',
    component: Component_content_HeadlineWithIconList,
    metadata: Component_content_HeadlineWithIconList_Meta && Component_content_HeadlineWithIconList_Meta.default ? Component_content_HeadlineWithIconList_Meta.default : { friendlyName: 'Headline With Icon List' }
  },
  {
    name: 'IconFeatureGrid',
    friendlyName: 'Icon Feature Grid',
    component: Component_content_IconFeatureGrid,
    metadata: Component_content_IconFeatureGrid_Meta && Component_content_IconFeatureGrid_Meta.default ? Component_content_IconFeatureGrid_Meta.default : { friendlyName: 'Icon Feature Grid' }
  },
  {
    name: 'IconsListBlockCta',
    friendlyName: 'Icons List Block with CTA',
    component: Component_content_IconsListBlockCta,
    metadata: Component_content_IconsListBlockCta_Meta && Component_content_IconsListBlockCta_Meta.default ? Component_content_IconsListBlockCta_Meta.default : { friendlyName: 'Icons List Block with CTA' }
  },
  {
    name: 'IconsTextWithVisualSection',
    friendlyName: 'Icons Text With Visual Section',
    component: Component_content_IconsTextWithVisualSection,
    metadata: Component_content_IconsTextWithVisualSection_Meta && Component_content_IconsTextWithVisualSection_Meta.default ? Component_content_IconsTextWithVisualSection_Meta.default : { friendlyName: 'Icons Text With Visual Section' }
  },
  {
    name: 'ImageLeftTextRight',
    friendlyName: 'Image Left Text Right',
    component: Component_content_ImageLeftTextRight,
    metadata: Component_content_ImageLeftTextRight_Meta && Component_content_ImageLeftTextRight_Meta.default ? Component_content_ImageLeftTextRight_Meta.default : { friendlyName: 'Image Left Text Right' }
  },
  {
    name: 'InfoContentImage',
    friendlyName: 'Info Content With Image',
    component: Component_content_InfoContentImage,
    metadata: Component_content_InfoContentImage_Meta && Component_content_InfoContentImage_Meta.default ? Component_content_InfoContentImage_Meta.default : { friendlyName: 'Info Content With Image' }
  },
  {
    name: 'InfoWithFullILeftmage',
    friendlyName: 'InfoWithFullLeftImage',
    component: Component_content_InfoWithFullILeftmage,
    metadata: Component_content_InfoWithFullILeftmage_Meta && Component_content_InfoWithFullILeftmage_Meta.default ? Component_content_InfoWithFullILeftmage_Meta.default : { friendlyName: 'InfoWithFullLeftImage' }
  },
  {
    name: 'InfoWithFullILeftmageStyleTwo',
    friendlyName: 'InfoWithFullLeftImageStyleTwo',
    component: Component_content_InfoWithFullILeftmageStyleTwo,
    metadata: Component_content_InfoWithFullILeftmageStyleTwo_Meta && Component_content_InfoWithFullILeftmageStyleTwo_Meta.default ? Component_content_InfoWithFullILeftmageStyleTwo_Meta.default : { friendlyName: 'InfoWithFullLeftImageStyleTwo' }
  },
  {
    name: 'InfoWithFullRightImage',
    friendlyName: 'InfoWithFullRightImage',
    component: Component_content_InfoWithFullRightImage,
    metadata: Component_content_InfoWithFullRightImage_Meta && Component_content_InfoWithFullRightImage_Meta.default ? Component_content_InfoWithFullRightImage_Meta.default : { friendlyName: 'InfoWithFullRightImage' }
  },
  {
    name: 'InfoWithFullRightImageStyleTwo',
    friendlyName: 'InfoWithFullRightImageStyleTwo',
    component: Component_content_InfoWithFullRightImageStyleTwo,
    metadata: Component_content_InfoWithFullRightImageStyleTwo_Meta && Component_content_InfoWithFullRightImageStyleTwo_Meta.default ? Component_content_InfoWithFullRightImageStyleTwo_Meta.default : { friendlyName: 'InfoWithFullRightImageStyleTwo' }
  },
  {
    name: 'InfoWithLeftImage',
    friendlyName: 'InfoWithLeftImage',
    component: Component_content_InfoWithLeftImage,
    metadata: Component_content_InfoWithLeftImage_Meta && Component_content_InfoWithLeftImage_Meta.default ? Component_content_InfoWithLeftImage_Meta.default : { friendlyName: 'InfoWithLeftImage' }
  },
  {
    name: 'InfoWithRightImage',
    friendlyName: 'InfoWithRightImage',
    component: Component_content_InfoWithRightImage,
    metadata: Component_content_InfoWithRightImage_Meta && Component_content_InfoWithRightImage_Meta.default ? Component_content_InfoWithRightImage_Meta.default : { friendlyName: 'InfoWithRightImage' }
  },
  {
    name: 'PriceComparison',
    friendlyName: 'Price Comparison',
    component: Component_content_PriceComparison,
    metadata: Component_content_PriceComparison_Meta && Component_content_PriceComparison_Meta.default ? Component_content_PriceComparison_Meta.default : { friendlyName: 'Price Comparison' }
  },
  {
    name: 'ProductInfoWithVisual',
    friendlyName: 'Product Info With Visual',
    component: Component_content_ProductInfoWithVisual,
    metadata: Component_content_ProductInfoWithVisual_Meta && Component_content_ProductInfoWithVisual_Meta.default ? Component_content_ProductInfoWithVisual_Meta.default : { friendlyName: 'Product Info With Visual' }
  },
  {
    name: 'ProductOffer',
    friendlyName: 'Product Offer',
    component: Component_content_ProductOffer,
    metadata: Component_content_ProductOffer_Meta && Component_content_ProductOffer_Meta.default ? Component_content_ProductOffer_Meta.default : { friendlyName: 'Product Offer' }
  },
  {
    name: 'References',
    friendlyName: 'ReferencesWithTitle',
    component: Component_content_References,
    metadata: Component_content_References_Meta && Component_content_References_Meta.default ? Component_content_References_Meta.default : { friendlyName: 'ReferencesWithTitle' }
  },
  {
    name: 'TextDescriptionBonus',
    friendlyName: 'TextDescriptionBonus',
    component: Component_content_TextDescriptionBonus,
    metadata: Component_content_TextDescriptionBonus_Meta && Component_content_TextDescriptionBonus_Meta.default ? Component_content_TextDescriptionBonus_Meta.default : { friendlyName: 'TextDescriptionBonus' }
  },
  {
    name: 'TextDescriptionCompareBlock',
    friendlyName: 'Content - Text Description Compare Block',
    component: Component_content_TextDescriptionCompareBlock,
    metadata: Component_content_TextDescriptionCompareBlock_Meta && Component_content_TextDescriptionCompareBlock_Meta.default ? Component_content_TextDescriptionCompareBlock_Meta.default : { friendlyName: 'Content - Text Description Compare Block' }
  },
  {
    name: 'TextDescriptionFullImage',
    friendlyName: 'TextDescriptionFullImage',
    component: Component_content_TextDescriptionFullImage,
    metadata: Component_content_TextDescriptionFullImage_Meta && Component_content_TextDescriptionFullImage_Meta.default ? Component_content_TextDescriptionFullImage_Meta.default : { friendlyName: 'TextDescriptionFullImage' }
  },
  {
    name: 'TextImageSplit',
    friendlyName: 'TextImageSplit',
    component: Component_content_TextImageSplit,
    metadata: Component_content_TextImageSplit_Meta && Component_content_TextImageSplit_Meta.default ? Component_content_TextImageSplit_Meta.default : { friendlyName: 'TextImageSplit' }
  },
  {
    name: 'TextImageSplitIngredients',
    friendlyName: 'Text Image Split Ingredients',
    component: Component_content_TextImageSplitIngredients,
    metadata: Component_content_TextImageSplitIngredients_Meta && Component_content_TextImageSplitIngredients_Meta.default ? Component_content_TextImageSplitIngredients_Meta.default : { friendlyName: 'Text Image Split Ingredients' }
  },
  {
    name: 'TextRightImage',
    friendlyName: 'TextRightImage',
    component: Component_content_TextRightImage,
    metadata: Component_content_TextRightImage_Meta && Component_content_TextRightImage_Meta.default ? Component_content_TextRightImage_Meta.default : { friendlyName: 'TextRightImage' }
  },
  {
    name: 'TitleInfoPriceProduct',
    friendlyName: 'Title Info Price Product',
    component: Component_content_TitleInfoPriceProduct,
    metadata: Component_content_TitleInfoPriceProduct_Meta && Component_content_TitleInfoPriceProduct_Meta.default ? Component_content_TitleInfoPriceProduct_Meta.default : { friendlyName: 'Title Info Price Product' }
  },
  {
    name: 'TitleInfoSmall',
    friendlyName: 'Title Info Small',
    component: Component_content_TitleInfoSmall,
    metadata: Component_content_TitleInfoSmall_Meta && Component_content_TitleInfoSmall_Meta.default ? Component_content_TitleInfoSmall_Meta.default : { friendlyName: 'Title Info Small' }
  },
  {
    name: 'TitlePointsInfoBox',
    friendlyName: 'Title Points Info Box',
    component: Component_content_TitlePointsInfoBox,
    metadata: Component_content_TitlePointsInfoBox_Meta && Component_content_TitlePointsInfoBox_Meta.default ? Component_content_TitlePointsInfoBox_Meta.default : { friendlyName: 'Title Points Info Box' }
  },
  {
    name: 'TitleWithParagraphLead',
    friendlyName: 'Title With Paragraph Lead',
    component: Component_content_TitleWithParagraphLead,
    metadata: Component_content_TitleWithParagraphLead_Meta && Component_content_TitleWithParagraphLead_Meta.default ? Component_content_TitleWithParagraphLead_Meta.default : { friendlyName: 'Title With Paragraph Lead' }
  },
  {
    name: 'VisualUseCasesFlow',
    friendlyName: 'VisualUseCasesFlow',
    component: Component_content_VisualUseCasesFlow,
    metadata: Component_content_VisualUseCasesFlow_Meta && Component_content_VisualUseCasesFlow_Meta.default ? Component_content_VisualUseCasesFlow_Meta.default : { friendlyName: 'VisualUseCasesFlow' }
  },
  {
    name: 'logoRightText',
    friendlyName: 'LogoRightText',
    component: Component_content_logoRightText,
    metadata: Component_content_logoRightText_Meta && Component_content_logoRightText_Meta.default ? Component_content_logoRightText_Meta.default : { friendlyName: 'LogoRightText' }
  },
  {
    name: 'button',
    friendlyName: 'CTA Button',
    component: Component_cta_button,
    metadata: Component_cta_button_Meta && Component_cta_button_Meta.default ? Component_cta_button_Meta.default : { friendlyName: 'CTA Button' }
  },
  {
    name: 'buttonWithText',
    friendlyName: 'CTA Button with Text',
    component: Component_cta_buttonWithText,
    metadata: Component_cta_buttonWithText_Meta && Component_cta_buttonWithText_Meta.default ? Component_cta_buttonWithText_Meta.default : { friendlyName: 'CTA Button with Text' }
  },
  {
    name: 'CTAWithBadge',
    friendlyName: 'CTAWithBadge',
    component: Component_ctas_CTAWithBadge,
    metadata: Component_ctas_CTAWithBadge_Meta && Component_ctas_CTAWithBadge_Meta.default ? Component_ctas_CTAWithBadge_Meta.default : { friendlyName: 'CTAWithBadge' }
  },
  {
    name: 'CalculatorSavingsProjection',
    friendlyName: 'CalculatorSavingsProjection',
    component: Component_elements_CalculatorSavingsProjection,
    metadata: Component_elements_CalculatorSavingsProjection_Meta && Component_elements_CalculatorSavingsProjection_Meta.default ? Component_elements_CalculatorSavingsProjection_Meta.default : { friendlyName: 'CalculatorSavingsProjection' }
  },
  {
    name: 'accordion',
    friendlyName: 'FAQ Accordion',
    component: Component_faq_accordion,
    metadata: Component_faq_accordion_Meta && Component_faq_accordion_Meta.default ? Component_faq_accordion_Meta.default : { friendlyName: 'FAQ Accordion' }
  },
  {
    name: 'FAQWithImage',
    friendlyName: 'FAQWithImage',
    component: Component_faqs_FAQWithImage,
    metadata: Component_faqs_FAQWithImage_Meta && Component_faqs_FAQWithImage_Meta.default ? Component_faqs_FAQWithImage_Meta.default : { friendlyName: 'FAQWithImage' }
  },
  {
    name: 'lifeboostFooter',
    friendlyName: 'LifeboostFooter',
    component: Component_footer_lifeboostFooter,
    metadata: Component_footer_lifeboostFooter_Meta && Component_footer_lifeboostFooter_Meta.default ? Component_footer_lifeboostFooter_Meta.default : { friendlyName: 'LifeboostFooter' }
  },
  {
    name: 'salesBasicBg',
    friendlyName: 'Footer Sales Basic Bg',
    component: Component_footer_salesBasicBg,
    metadata: Component_footer_salesBasicBg_Meta && Component_footer_salesBasicBg_Meta.default ? Component_footer_salesBasicBg_Meta.default : { friendlyName: 'Footer Sales Basic Bg' }
  },
  {
    name: 'simpleFooter',
    friendlyName: 'SimpleFooter',
    component: Component_footer_simpleFooter,
    metadata: Component_footer_simpleFooter_Meta && Component_footer_simpleFooter_Meta.default ? Component_footer_simpleFooter_Meta.default : { friendlyName: 'SimpleFooter' }
  },
  {
    name: 'ContentWithForm',
    friendlyName: 'ContentWithForm',
    component: Component_forms_ContentWithForm,
    metadata: Component_forms_ContentWithForm_Meta && Component_forms_ContentWithForm_Meta.default ? Component_forms_ContentWithForm_Meta.default : { friendlyName: 'ContentWithForm' }
  },
  {
    name: 'Footer',
    friendlyName: 'Main Footer',
    component: Component_frostedCookieBuilder_Footer,
    metadata: Component_frostedCookieBuilder_Footer_Meta && Component_frostedCookieBuilder_Footer_Meta.default ? Component_frostedCookieBuilder_Footer_Meta.default : { friendlyName: 'Main Footer' }
  },
  {
    name: 'SwatchesType3',
    friendlyName: 'Swatches Type 3',
    component: Component_frostedCookieBuilder_SwatchesType3,
    metadata: Component_frostedCookieBuilder_SwatchesType3_Meta && Component_frostedCookieBuilder_SwatchesType3_Meta.default ? Component_frostedCookieBuilder_SwatchesType3_Meta.default : { friendlyName: 'Swatches Type 3' }
  },
  {
    name: 'banner',
    friendlyName: 'banner',
    component: Component_header_banner,
    metadata: Component_header_banner_Meta && Component_header_banner_Meta.default ? Component_header_banner_Meta.default : { friendlyName: 'banner' }
  },
  {
    name: 'basic',
    friendlyName: 'Basic Header',
    component: Component_header_basic,
    metadata: Component_header_basic_Meta && Component_header_basic_Meta.default ? Component_header_basic_Meta.default : { friendlyName: 'Basic Header' }
  },
  {
    name: 'AllPeople',
    friendlyName: 'AllPeople',
    component: Component_healthyCoffee1_AllPeople,
    metadata: Component_healthyCoffee1_AllPeople_Meta && Component_healthyCoffee1_AllPeople_Meta.default ? Component_healthyCoffee1_AllPeople_Meta.default : { friendlyName: 'AllPeople' }
  },
  {
    name: 'BannerDiscount',
    friendlyName: 'BannerDiscount',
    component: Component_healthyCoffee1_BannerDiscount,
    metadata: Component_healthyCoffee1_BannerDiscount_Meta && Component_healthyCoffee1_BannerDiscount_Meta.default ? Component_healthyCoffee1_BannerDiscount_Meta.default : { friendlyName: 'BannerDiscount' }
  },
  {
    name: 'ButtonTest',
    friendlyName: 'ButtonABTest',
    component: Component_healthyCoffee1_ButtonTest,
    metadata: Component_healthyCoffee1_ButtonTest_Meta && Component_healthyCoffee1_ButtonTest_Meta.default ? Component_healthyCoffee1_ButtonTest_Meta.default : { friendlyName: 'ButtonABTest' }
  },
  {
    name: 'Comment',
    friendlyName: 'Comment',
    component: Component_healthyCoffee1_Comment,
    metadata: Component_healthyCoffee1_Comment_Meta && Component_healthyCoffee1_Comment_Meta.default ? Component_healthyCoffee1_Comment_Meta.default : { friendlyName: 'Comment' }
  },
  {
    name: 'DrinkCoffee',
    friendlyName: 'DrinkCoffee',
    component: Component_healthyCoffee1_DrinkCoffee,
    metadata: Component_healthyCoffee1_DrinkCoffee_Meta && Component_healthyCoffee1_DrinkCoffee_Meta.default ? Component_healthyCoffee1_DrinkCoffee_Meta.default : { friendlyName: 'DrinkCoffee' }
  },
  {
    name: 'Footer',
    friendlyName: 'Footer',
    component: Component_healthyCoffee1_Footer,
    metadata: Component_healthyCoffee1_Footer_Meta && Component_healthyCoffee1_Footer_Meta.default ? Component_healthyCoffee1_Footer_Meta.default : { friendlyName: 'Footer' }
  },
  {
    name: 'FounderLifeBoost',
    friendlyName: 'FounderLifeBoost',
    component: Component_healthyCoffee1_FounderLifeBoost,
    metadata: Component_healthyCoffee1_FounderLifeBoost_Meta && Component_healthyCoffee1_FounderLifeBoost_Meta.default ? Component_healthyCoffee1_FounderLifeBoost_Meta.default : { friendlyName: 'FounderLifeBoost' }
  },
  {
    name: 'FreeShiping',
    friendlyName: 'FreeShipping',
    component: Component_healthyCoffee1_FreeShiping,
    metadata: Component_healthyCoffee1_FreeShiping_Meta && Component_healthyCoffee1_FreeShiping_Meta.default ? Component_healthyCoffee1_FreeShiping_Meta.default : { friendlyName: 'FreeShipping' }
  },
  {
    name: 'FreeShipingImages',
    friendlyName: 'FreeShippingImages',
    component: Component_healthyCoffee1_FreeShipingImages,
    metadata: Component_healthyCoffee1_FreeShipingImages_Meta && Component_healthyCoffee1_FreeShipingImages_Meta.default ? Component_healthyCoffee1_FreeShipingImages_Meta.default : { friendlyName: 'FreeShippingImages' }
  },
  {
    name: 'FromDesk',
    friendlyName: 'FromDesk',
    component: Component_healthyCoffee1_FromDesk,
    metadata: Component_healthyCoffee1_FromDesk_Meta && Component_healthyCoffee1_FromDesk_Meta.default ? Component_healthyCoffee1_FromDesk_Meta.default : { friendlyName: 'FromDesk' }
  },
  {
    name: 'FromMyHouse-2',
    friendlyName: 'FromMyHouse-2',
    component: Component_healthyCoffee1_FromMyHouse_2,
    metadata: Component_healthyCoffee1_FromMyHouse_2_Meta && Component_healthyCoffee1_FromMyHouse_2_Meta.default ? Component_healthyCoffee1_FromMyHouse_2_Meta.default : { friendlyName: 'FromMyHouse-2' }
  },
  {
    name: 'FromMyHouse',
    friendlyName: 'FromMyHouse',
    component: Component_healthyCoffee1_FromMyHouse,
    metadata: Component_healthyCoffee1_FromMyHouse_Meta && Component_healthyCoffee1_FromMyHouse_Meta.default ? Component_healthyCoffee1_FromMyHouse_Meta.default : { friendlyName: 'FromMyHouse' }
  },
  {
    name: 'Generation-2',
    friendlyName: 'ResilienceHopeCup-2',
    component: Component_healthyCoffee1_Generation_2,
    metadata: Component_healthyCoffee1_Generation_2_Meta && Component_healthyCoffee1_Generation_2_Meta.default ? Component_healthyCoffee1_Generation_2_Meta.default : { friendlyName: 'ResilienceHopeCup-2' }
  },
  {
    name: 'Generation',
    friendlyName: 'ResilienceHopeCup',
    component: Component_healthyCoffee1_Generation,
    metadata: Component_healthyCoffee1_Generation_Meta && Component_healthyCoffee1_Generation_Meta.default ? Component_healthyCoffee1_Generation_Meta.default : { friendlyName: 'ResilienceHopeCup' }
  },
  {
    name: 'Header',
    friendlyName: 'Header',
    component: Component_healthyCoffee1_Header,
    metadata: Component_healthyCoffee1_Header_Meta && Component_healthyCoffee1_Header_Meta.default ? Component_healthyCoffee1_Header_Meta.default : { friendlyName: 'Header' }
  },
  {
    name: 'Hero',
    friendlyName: 'Hero',
    component: Component_healthyCoffee1_Hero,
    metadata: Component_healthyCoffee1_Hero_Meta && Component_healthyCoffee1_Hero_Meta.default ? Component_healthyCoffee1_Hero_Meta.default : { friendlyName: 'Hero' }
  },
  {
    name: 'Influencers',
    friendlyName: 'Influencers',
    component: Component_healthyCoffee1_Influencers,
    metadata: Component_healthyCoffee1_Influencers_Meta && Component_healthyCoffee1_Influencers_Meta.default ? Component_healthyCoffee1_Influencers_Meta.default : { friendlyName: 'Influencers' }
  },
  {
    name: 'LifeBoostIncludes-2',
    friendlyName: 'LifeBoostIncludes-2',
    component: Component_healthyCoffee1_LifeBoostIncludes_2,
    metadata: Component_healthyCoffee1_LifeBoostIncludes_2_Meta && Component_healthyCoffee1_LifeBoostIncludes_2_Meta.default ? Component_healthyCoffee1_LifeBoostIncludes_2_Meta.default : { friendlyName: 'LifeBoostIncludes-2' }
  },
  {
    name: 'LifeBoostIncludes',
    friendlyName: 'LifeBoostIncludes',
    component: Component_healthyCoffee1_LifeBoostIncludes,
    metadata: Component_healthyCoffee1_LifeBoostIncludes_Meta && Component_healthyCoffee1_LifeBoostIncludes_Meta.default ? Component_healthyCoffee1_LifeBoostIncludes_Meta.default : { friendlyName: 'LifeBoostIncludes' }
  },
  {
    name: 'PeopleHaveToSay',
    friendlyName: 'PeopleHaveToSay',
    component: Component_healthyCoffee1_PeopleHaveToSay,
    metadata: Component_healthyCoffee1_PeopleHaveToSay_Meta && Component_healthyCoffee1_PeopleHaveToSay_Meta.default ? Component_healthyCoffee1_PeopleHaveToSay_Meta.default : { friendlyName: 'PeopleHaveToSay' }
  },
  {
    name: 'Qualities',
    friendlyName: 'Qualities',
    component: Component_healthyCoffee1_Qualities,
    metadata: Component_healthyCoffee1_Qualities_Meta && Component_healthyCoffee1_Qualities_Meta.default ? Component_healthyCoffee1_Qualities_Meta.default : { friendlyName: 'Qualities' }
  },
  {
    name: 'QualitiesMore',
    friendlyName: 'QualitiesMore',
    component: Component_healthyCoffee1_QualitiesMore,
    metadata: Component_healthyCoffee1_QualitiesMore_Meta && Component_healthyCoffee1_QualitiesMore_Meta.default ? Component_healthyCoffee1_QualitiesMore_Meta.default : { friendlyName: 'QualitiesMore' }
  },
  {
    name: 'Review-2',
    friendlyName: 'Review-2',
    component: Component_healthyCoffee1_Review_2,
    metadata: Component_healthyCoffee1_Review_2_Meta && Component_healthyCoffee1_Review_2_Meta.default ? Component_healthyCoffee1_Review_2_Meta.default : { friendlyName: 'Review-2' }
  },
  {
    name: 'Review',
    friendlyName: 'Review',
    component: Component_healthyCoffee1_Review,
    metadata: Component_healthyCoffee1_Review_Meta && Component_healthyCoffee1_Review_Meta.default ? Component_healthyCoffee1_Review_Meta.default : { friendlyName: 'Review' }
  },
  {
    name: 'ReviewShort',
    friendlyName: 'ReviewShort',
    component: Component_healthyCoffee1_ReviewShort,
    metadata: Component_healthyCoffee1_ReviewShort_Meta && Component_healthyCoffee1_ReviewShort_Meta.default ? Component_healthyCoffee1_ReviewShort_Meta.default : { friendlyName: 'ReviewShort' }
  },
  {
    name: 'SimpleImage',
    friendlyName: 'SimpleImage',
    component: Component_healthyCoffee1_SimpleImage,
    metadata: Component_healthyCoffee1_SimpleImage_Meta && Component_healthyCoffee1_SimpleImage_Meta.default ? Component_healthyCoffee1_SimpleImage_Meta.default : { friendlyName: 'SimpleImage' }
  },
  {
    name: 'Swatches',
    friendlyName: 'Swatches',
    component: Component_healthyCoffee1_Swatches,
    metadata: Component_healthyCoffee1_Swatches_Meta && Component_healthyCoffee1_Swatches_Meta.default ? Component_healthyCoffee1_Swatches_Meta.default : { friendlyName: 'Swatches' }
  },
  {
    name: 'SwatchesTest-9',
    friendlyName: 'SwatchesTest-9',
    component: Component_healthyCoffee1_SwatchesTest_9,
    metadata: Component_healthyCoffee1_SwatchesTest_9_Meta && Component_healthyCoffee1_SwatchesTest_9_Meta.default ? Component_healthyCoffee1_SwatchesTest_9_Meta.default : { friendlyName: 'SwatchesTest-9' }
  },
  {
    name: 'SwatchesTest8-5',
    friendlyName: 'SwatchesTest8-5',
    component: Component_healthyCoffee1_SwatchesTest8_5,
    metadata: Component_healthyCoffee1_SwatchesTest8_5_Meta && Component_healthyCoffee1_SwatchesTest8_5_Meta.default ? Component_healthyCoffee1_SwatchesTest8_5_Meta.default : { friendlyName: 'SwatchesTest8-5' }
  },
  {
    name: 'SwatchesTest8',
    friendlyName: 'SwatchesTest8',
    component: Component_healthyCoffee1_SwatchesTest8,
    metadata: Component_healthyCoffee1_SwatchesTest8_Meta && Component_healthyCoffee1_SwatchesTest8_Meta.default ? Component_healthyCoffee1_SwatchesTest8_Meta.default : { friendlyName: 'SwatchesTest8' }
  },
  {
    name: 'SwatchesVariant-2',
    friendlyName: 'SwatchesVariant-2',
    component: Component_healthyCoffee1_SwatchesVariant_2,
    metadata: Component_healthyCoffee1_SwatchesVariant_2_Meta && Component_healthyCoffee1_SwatchesVariant_2_Meta.default ? Component_healthyCoffee1_SwatchesVariant_2_Meta.default : { friendlyName: 'SwatchesVariant-2' }
  },
  {
    name: 'SwatchesVariant',
    friendlyName: 'SwatchesVariant',
    component: Component_healthyCoffee1_SwatchesVariant,
    metadata: Component_healthyCoffee1_SwatchesVariant_Meta && Component_healthyCoffee1_SwatchesVariant_Meta.default ? Component_healthyCoffee1_SwatchesVariant_Meta.default : { friendlyName: 'SwatchesVariant' }
  },
  {
    name: 'Testimonials',
    friendlyName: 'Testimonials',
    component: Component_healthyCoffee1_Testimonials,
    metadata: Component_healthyCoffee1_Testimonials_Meta && Component_healthyCoffee1_Testimonials_Meta.default ? Component_healthyCoffee1_Testimonials_Meta.default : { friendlyName: 'Testimonials' }
  },
  {
    name: 'TitleWithPoint',
    friendlyName: 'TitleWithPoints',
    component: Component_healthyCoffee1_TitleWithPoint,
    metadata: Component_healthyCoffee1_TitleWithPoint_Meta && Component_healthyCoffee1_TitleWithPoint_Meta.default ? Component_healthyCoffee1_TitleWithPoint_Meta.default : { friendlyName: 'TitleWithPoints' }
  },
  {
    name: 'aboutText',
    friendlyName: 'AboutText',
    component: Component_healthyCoffee1_aboutText,
    metadata: Component_healthyCoffee1_aboutText_Meta && Component_healthyCoffee1_aboutText_Meta.default ? Component_healthyCoffee1_aboutText_Meta.default : { friendlyName: 'AboutText' }
  },
  {
    name: 'AllPeople',
    friendlyName: 'AllPeople2',
    component: Component_healtyCoffee22Builder_AllPeople,
    metadata: Component_healtyCoffee22Builder_AllPeople_Meta && Component_healtyCoffee22Builder_AllPeople_Meta.default ? Component_healtyCoffee22Builder_AllPeople_Meta.default : { friendlyName: 'AllPeople2' }
  },
  {
    name: 'AllPeopleImage',
    friendlyName: 'AllPeopleImage',
    component: Component_healtyCoffee22Builder_AllPeopleImage,
    metadata: Component_healtyCoffee22Builder_AllPeopleImage_Meta && Component_healtyCoffee22Builder_AllPeopleImage_Meta.default ? Component_healtyCoffee22Builder_AllPeopleImage_Meta.default : { friendlyName: 'AllPeopleImage' }
  },
  {
    name: 'BackgroundImage',
    friendlyName: 'Background Image',
    component: Component_healtyCoffee22Builder_BackgroundImage,
    metadata: Component_healtyCoffee22Builder_BackgroundImage_Meta && Component_healtyCoffee22Builder_BackgroundImage_Meta.default ? Component_healtyCoffee22Builder_BackgroundImage_Meta.default : { friendlyName: 'Background Image' }
  },
  {
    name: 'BackgroundImageText',
    friendlyName: 'Background Image Text',
    component: Component_healtyCoffee22Builder_BackgroundImageText,
    metadata: Component_healtyCoffee22Builder_BackgroundImageText_Meta && Component_healtyCoffee22Builder_BackgroundImageText_Meta.default ? Component_healtyCoffee22Builder_BackgroundImageText_Meta.default : { friendlyName: 'Background Image Text' }
  },
  {
    name: 'Button',
    friendlyName: 'ButtonHealthyCoffee22',
    component: Component_healtyCoffee22Builder_Button,
    metadata: Component_healtyCoffee22Builder_Button_Meta && Component_healtyCoffee22Builder_Button_Meta.default ? Component_healtyCoffee22Builder_Button_Meta.default : { friendlyName: 'ButtonHealthyCoffee22' }
  },
  {
    name: 'ContentBottomImages',
    friendlyName: 'Content Bottom Images',
    component: Component_healtyCoffee22Builder_ContentBottomImages,
    metadata: Component_healtyCoffee22Builder_ContentBottomImages_Meta && Component_healtyCoffee22Builder_ContentBottomImages_Meta.default ? Component_healtyCoffee22Builder_ContentBottomImages_Meta.default : { friendlyName: 'Content Bottom Images' }
  },
  {
    name: 'ContentImageLeft3',
    friendlyName: 'Content Image Left3',
    component: Component_healtyCoffee22Builder_ContentImageLeft3,
    metadata: Component_healtyCoffee22Builder_ContentImageLeft3_Meta && Component_healtyCoffee22Builder_ContentImageLeft3_Meta.default ? Component_healtyCoffee22Builder_ContentImageLeft3_Meta.default : { friendlyName: 'Content Image Left3' }
  },
  {
    name: 'ContentImageRight2',
    friendlyName: 'Content Image Right2',
    component: Component_healtyCoffee22Builder_ContentImageRight2,
    metadata: Component_healtyCoffee22Builder_ContentImageRight2_Meta && Component_healtyCoffee22Builder_ContentImageRight2_Meta.default ? Component_healtyCoffee22Builder_ContentImageRight2_Meta.default : { friendlyName: 'Content Image Right2' }
  },
  {
    name: 'ContentLeftImage',
    friendlyName: 'Content Left Image',
    component: Component_healtyCoffee22Builder_ContentLeftImage,
    metadata: Component_healtyCoffee22Builder_ContentLeftImage_Meta && Component_healtyCoffee22Builder_ContentLeftImage_Meta.default ? Component_healtyCoffee22Builder_ContentLeftImage_Meta.default : { friendlyName: 'Content Left Image' }
  },
  {
    name: 'ContentLeftimage2',
    friendlyName: 'Content Left Image2',
    component: Component_healtyCoffee22Builder_ContentLeftimage2,
    metadata: Component_healtyCoffee22Builder_ContentLeftimage2_Meta && Component_healtyCoffee22Builder_ContentLeftimage2_Meta.default ? Component_healtyCoffee22Builder_ContentLeftimage2_Meta.default : { friendlyName: 'Content Left Image2' }
  },
  {
    name: 'ContentRightImage',
    friendlyName: 'Content Right Image',
    component: Component_healtyCoffee22Builder_ContentRightImage,
    metadata: Component_healtyCoffee22Builder_ContentRightImage_Meta && Component_healtyCoffee22Builder_ContentRightImage_Meta.default ? Component_healtyCoffee22Builder_ContentRightImage_Meta.default : { friendlyName: 'Content Right Image' }
  },
  {
    name: 'ContentSectionWithSvg',
    friendlyName: 'Content Section With Svg',
    component: Component_healtyCoffee22Builder_ContentSectionWithSvg,
    metadata: Component_healtyCoffee22Builder_ContentSectionWithSvg_Meta && Component_healtyCoffee22Builder_ContentSectionWithSvg_Meta.default ? Component_healtyCoffee22Builder_ContentSectionWithSvg_Meta.default : { friendlyName: 'Content Section With Svg' }
  },
  {
    name: 'ContentTextImage',
    friendlyName: 'ContentTextImage',
    component: Component_healtyCoffee22Builder_ContentTextImage,
    metadata: Component_healtyCoffee22Builder_ContentTextImage_Meta && Component_healtyCoffee22Builder_ContentTextImage_Meta.default ? Component_healtyCoffee22Builder_ContentTextImage_Meta.default : { friendlyName: 'ContentTextImage' }
  },
  {
    name: 'FromDesk2',
    friendlyName: 'FromDesk2',
    component: Component_healtyCoffee22Builder_FromDesk2,
    metadata: Component_healtyCoffee22Builder_FromDesk2_Meta && Component_healtyCoffee22Builder_FromDesk2_Meta.default ? Component_healtyCoffee22Builder_FromDesk2_Meta.default : { friendlyName: 'FromDesk2' }
  },
  {
    name: 'ImagesLine2',
    friendlyName: 'ImageLine2',
    component: Component_healtyCoffee22Builder_ImagesLine2,
    metadata: Component_healtyCoffee22Builder_ImagesLine2_Meta && Component_healtyCoffee22Builder_ImagesLine2_Meta.default ? Component_healtyCoffee22Builder_ImagesLine2_Meta.default : { friendlyName: 'ImageLine2' }
  },
  {
    name: 'LogoSection',
    friendlyName: 'Logos Coffee',
    component: Component_healtyCoffee22Builder_LogoSection,
    metadata: Component_healtyCoffee22Builder_LogoSection_Meta && Component_healtyCoffee22Builder_LogoSection_Meta.default ? Component_healtyCoffee22Builder_LogoSection_Meta.default : { friendlyName: 'Logos Coffee' }
  },
  {
    name: 'References',
    friendlyName: 'References',
    component: Component_healtyCoffee22Builder_References,
    metadata: Component_healtyCoffee22Builder_References_Meta && Component_healtyCoffee22Builder_References_Meta.default ? Component_healtyCoffee22Builder_References_Meta.default : { friendlyName: 'References' }
  },
  {
    name: 'Reviews2',
    friendlyName: 'Reviews2',
    component: Component_healtyCoffee22Builder_Reviews2,
    metadata: Component_healtyCoffee22Builder_Reviews2_Meta && Component_healtyCoffee22Builder_Reviews2_Meta.default ? Component_healtyCoffee22Builder_Reviews2_Meta.default : { friendlyName: 'Reviews2' }
  },
  {
    name: 'Reviews3',
    friendlyName: 'Reviews3',
    component: Component_healtyCoffee22Builder_Reviews3,
    metadata: Component_healtyCoffee22Builder_Reviews3_Meta && Component_healtyCoffee22Builder_Reviews3_Meta.default ? Component_healtyCoffee22Builder_Reviews3_Meta.default : { friendlyName: 'Reviews3' }
  },
  {
    name: 'SectionWithVideo',
    friendlyName: 'SectionWithVideo',
    component: Component_healtyCoffee22Builder_SectionWithVideo,
    metadata: Component_healtyCoffee22Builder_SectionWithVideo_Meta && Component_healtyCoffee22Builder_SectionWithVideo_Meta.default ? Component_healtyCoffee22Builder_SectionWithVideo_Meta.default : { friendlyName: 'SectionWithVideo' }
  },
  {
    name: 'SwatchesType2',
    friendlyName: 'SwatchesType2',
    component: Component_healtyCoffee22Builder_SwatchesType2,
    metadata: Component_healtyCoffee22Builder_SwatchesType2_Meta && Component_healtyCoffee22Builder_SwatchesType2_Meta.default ? Component_healtyCoffee22Builder_SwatchesType2_Meta.default : { friendlyName: 'SwatchesType2' }
  },
  {
    name: 'benefits',
    friendlyName: 'Benefits',
    component: Component_healtyCoffee22Builder_benefits,
    metadata: Component_healtyCoffee22Builder_benefits_Meta && Component_healtyCoffee22Builder_benefits_Meta.default ? Component_healtyCoffee22Builder_benefits_Meta.default : { friendlyName: 'Benefits' }
  },
  {
    name: 'content',
    friendlyName: 'Save now',
    component: Component_healtyCoffee22Builder_content,
    metadata: Component_healtyCoffee22Builder_content_Meta && Component_healtyCoffee22Builder_content_Meta.default ? Component_healtyCoffee22Builder_content_Meta.default : { friendlyName: 'Save now' }
  },
  {
    name: 'images-line',
    friendlyName: 'Images line',
    component: Component_healtyCoffee22Builder_images_line,
    metadata: Component_healtyCoffee22Builder_images_line_Meta && Component_healtyCoffee22Builder_images_line_Meta.default ? Component_healtyCoffee22Builder_images_line_Meta.default : { friendlyName: 'Images line' }
  },
  {
    name: 'info',
    friendlyName: 'Info',
    component: Component_healtyCoffee22Builder_info,
    metadata: Component_healtyCoffee22Builder_info_Meta && Component_healtyCoffee22Builder_info_Meta.default ? Component_healtyCoffee22Builder_info_Meta.default : { friendlyName: 'Info' }
  },
  {
    name: 'HeadTextCta',
    friendlyName: 'HeroTextCta',
    component: Component_hero_HeadTextCta,
    metadata: Component_hero_HeadTextCta_Meta && Component_hero_HeadTextCta_Meta.default ? Component_hero_HeadTextCta_Meta.default : { friendlyName: 'HeroTextCta' }
  },
  {
    name: 'HighlightNews',
    friendlyName: 'HeroHighlightNews',
    component: Component_hero_HighlightNews,
    metadata: Component_hero_HighlightNews_Meta && Component_hero_HighlightNews_Meta.default ? Component_hero_HighlightNews_Meta.default : { friendlyName: 'HeroHighlightNews' }
  },
  {
    name: 'ProductHeadline',
    friendlyName: 'ProductHeadline',
    component: Component_hero_ProductHeadline,
    metadata: Component_hero_ProductHeadline_Meta && Component_hero_ProductHeadline_Meta.default ? Component_hero_ProductHeadline_Meta.default : { friendlyName: 'ProductHeadline' }
  },
  {
    name: 'ProductIntro',
    friendlyName: 'Product Intro Hero',
    component: Component_hero_ProductIntro,
    metadata: Component_hero_ProductIntro_Meta && Component_hero_ProductIntro_Meta.default ? Component_hero_ProductIntro_Meta.default : { friendlyName: 'Product Intro Hero' }
  },
  {
    name: 'ProductWithShowcase',
    friendlyName: 'HeroProductWithShowcase',
    component: Component_hero_ProductWithShowcase,
    metadata: Component_hero_ProductWithShowcase_Meta && Component_hero_ProductWithShowcase_Meta.default ? Component_hero_ProductWithShowcase_Meta.default : { friendlyName: 'HeroProductWithShowcase' }
  },
  {
    name: 'TextInsightWithImage',
    friendlyName: 'Text Insight With Image Hero',
    component: Component_hero_TextInsightWithImage,
    metadata: Component_hero_TextInsightWithImage_Meta && Component_hero_TextInsightWithImage_Meta.default ? Component_hero_TextInsightWithImage_Meta.default : { friendlyName: 'Text Insight With Image Hero' }
  },
  {
    name: 'TitleDescriptionVideo',
    friendlyName: 'HeroTitleDescriptionVideo',
    component: Component_hero_TitleDescriptionVideo,
    metadata: Component_hero_TitleDescriptionVideo_Meta && Component_hero_TitleDescriptionVideo_Meta.default ? Component_hero_TitleDescriptionVideo_Meta.default : { friendlyName: 'HeroTitleDescriptionVideo' }
  },
  {
    name: 'TitleInfoImageCta',
    friendlyName: 'Hero - Title Info Image CTA',
    component: Component_hero_TitleInfoImageCta,
    metadata: Component_hero_TitleInfoImageCta_Meta && Component_hero_TitleInfoImageCta_Meta.default ? Component_hero_TitleInfoImageCta_Meta.default : { friendlyName: 'Hero - Title Info Image CTA' }
  },
  {
    name: 'VideoSignup',
    friendlyName: 'VideoSignup',
    component: Component_hero_VideoSignup,
    metadata: Component_hero_VideoSignup_Meta && Component_hero_VideoSignup_Meta.default ? Component_hero_VideoSignup_Meta.default : { friendlyName: 'VideoSignup' }
  },
  {
    name: 'ContentLefImage3',
    friendlyName: 'Content Left Image3',
    component: Component_lifeboostLatteBuilder_ContentLefImage3,
    metadata: Component_lifeboostLatteBuilder_ContentLefImage3_Meta && Component_lifeboostLatteBuilder_ContentLefImage3_Meta.default ? Component_lifeboostLatteBuilder_ContentLefImage3_Meta.default : { friendlyName: 'Content Left Image3' }
  },
  {
    name: 'DescriptionImageList',
    friendlyName: 'Description Image List',
    component: Component_lifeboostLatteBuilder_DescriptionImageList,
    metadata: Component_lifeboostLatteBuilder_DescriptionImageList_Meta && Component_lifeboostLatteBuilder_DescriptionImageList_Meta.default ? Component_lifeboostLatteBuilder_DescriptionImageList_Meta.default : { friendlyName: 'Description Image List' }
  },
  {
    name: 'DescriptionWithListPricing',
    friendlyName: 'Description With List Pricing',
    component: Component_lifeboostLatteBuilder_DescriptionWithListPricing,
    metadata: Component_lifeboostLatteBuilder_DescriptionWithListPricing_Meta && Component_lifeboostLatteBuilder_DescriptionWithListPricing_Meta.default ? Component_lifeboostLatteBuilder_DescriptionWithListPricing_Meta.default : { friendlyName: 'Description With List Pricing' }
  },
  {
    name: 'FDA',
    friendlyName: 'FDA Warning',
    component: Component_lifeboostLatteBuilder_FDA,
    metadata: Component_lifeboostLatteBuilder_FDA_Meta && Component_lifeboostLatteBuilder_FDA_Meta.default ? Component_lifeboostLatteBuilder_FDA_Meta.default : { friendlyName: 'FDA Warning' }
  },
  {
    name: 'Footer',
    friendlyName: 'Footer 2',
    component: Component_lifeboostLatteBuilder_Footer,
    metadata: Component_lifeboostLatteBuilder_Footer_Meta && Component_lifeboostLatteBuilder_Footer_Meta.default ? Component_lifeboostLatteBuilder_Footer_Meta.default : { friendlyName: 'Footer 2' }
  },
  {
    name: 'HeadingCTAButton',
    friendlyName: 'Heading CTA Button',
    component: Component_lifeboostLatteBuilder_HeadingCTAButton,
    metadata: Component_lifeboostLatteBuilder_HeadingCTAButton_Meta && Component_lifeboostLatteBuilder_HeadingCTAButton_Meta.default ? Component_lifeboostLatteBuilder_HeadingCTAButton_Meta.default : { friendlyName: 'Heading CTA Button' }
  },
  {
    name: 'Hero',
    friendlyName: 'Hero-2',
    component: Component_lifeboostLatteBuilder_Hero,
    metadata: Component_lifeboostLatteBuilder_Hero_Meta && Component_lifeboostLatteBuilder_Hero_Meta.default ? Component_lifeboostLatteBuilder_Hero_Meta.default : { friendlyName: 'Hero-2' }
  },
  {
    name: 'HomeSteps',
    friendlyName: 'Home Steps',
    component: Component_lifeboostLatteBuilder_HomeSteps,
    metadata: Component_lifeboostLatteBuilder_HomeSteps_Meta && Component_lifeboostLatteBuilder_HomeSteps_Meta.default ? Component_lifeboostLatteBuilder_HomeSteps_Meta.default : { friendlyName: 'Home Steps' }
  },
  {
    name: 'Reviews4',
    friendlyName: 'Reviews4',
    component: Component_lifeboostLatteBuilder_Reviews4,
    metadata: Component_lifeboostLatteBuilder_Reviews4_Meta && Component_lifeboostLatteBuilder_Reviews4_Meta.default ? Component_lifeboostLatteBuilder_Reviews4_Meta.default : { friendlyName: 'Reviews4' }
  },
  {
    name: 'TestimonialSwiper',
    friendlyName: 'Testimonial Swiper',
    component: Component_lifeboostLatteBuilder_TestimonialSwiper,
    metadata: Component_lifeboostLatteBuilder_TestimonialSwiper_Meta && Component_lifeboostLatteBuilder_TestimonialSwiper_Meta.default ? Component_lifeboostLatteBuilder_TestimonialSwiper_Meta.default : { friendlyName: 'Testimonial Swiper' }
  },
  {
    name: 'TextWithVideo',
    friendlyName: 'Text With Video',
    component: Component_lifeboostLatteBuilder_TextWithVideo,
    metadata: Component_lifeboostLatteBuilder_TextWithVideo_Meta && Component_lifeboostLatteBuilder_TextWithVideo_Meta.default ? Component_lifeboostLatteBuilder_TextWithVideo_Meta.default : { friendlyName: 'Text With Video' }
  },
  {
    name: 'InfoListWithSources',
    friendlyName: 'Info List With Sources',
    component: Component_lists_InfoListWithSources,
    metadata: Component_lists_InfoListWithSources_Meta && Component_lists_InfoListWithSources_Meta.default ? Component_lists_InfoListWithSources_Meta.default : { friendlyName: 'Info List With Sources' }
  },
  {
    name: 'ListFlex',
    friendlyName: 'ListFlex Logos',
    component: Component_logos_ListFlex,
    metadata: Component_logos_ListFlex_Meta && Component_logos_ListFlex_Meta.default ? Component_logos_ListFlex_Meta.default : { friendlyName: 'ListFlex Logos' }
  },
  {
    name: 'BackgroundTitleListImages',
    friendlyName: 'BackgroundTitleListImages',
    component: Component_mushroomBuilder_BackgroundTitleListImages,
    metadata: Component_mushroomBuilder_BackgroundTitleListImages_Meta && Component_mushroomBuilder_BackgroundTitleListImages_Meta.default ? Component_mushroomBuilder_BackgroundTitleListImages_Meta.default : { friendlyName: 'BackgroundTitleListImages' }
  },
  {
    name: 'BasicSwatches',
    friendlyName: 'BasicSwatches',
    component: Component_mushroomBuilder_BasicSwatches,
    metadata: Component_mushroomBuilder_BasicSwatches_Meta && Component_mushroomBuilder_BasicSwatches_Meta.default ? Component_mushroomBuilder_BasicSwatches_Meta.default : { friendlyName: 'BasicSwatches' }
  },
  {
    name: 'CoffeeGuarantee',
    friendlyName: 'CoffeeGuaranteePDP',
    component: Component_mushroomBuilder_CoffeeGuarantee,
    metadata: Component_mushroomBuilder_CoffeeGuarantee_Meta && Component_mushroomBuilder_CoffeeGuarantee_Meta.default ? Component_mushroomBuilder_CoffeeGuarantee_Meta.default : { friendlyName: 'CoffeeGuaranteePDP' }
  },
  {
    name: 'ContentWithRoundedIcons',
    friendlyName: 'ContentWithRoundedIcons',
    component: Component_mushroomBuilder_ContentWithRoundedIcons,
    metadata: Component_mushroomBuilder_ContentWithRoundedIcons_Meta && Component_mushroomBuilder_ContentWithRoundedIcons_Meta.default ? Component_mushroomBuilder_ContentWithRoundedIcons_Meta.default : { friendlyName: 'ContentWithRoundedIcons' }
  },
  {
    name: 'FrequentlyQuestionsTwoColumns',
    friendlyName: 'FrequentlyQuestionsTwoColumns',
    component: Component_mushroomBuilder_FrequentlyQuestionsTwoColumns,
    metadata: Component_mushroomBuilder_FrequentlyQuestionsTwoColumns_Meta && Component_mushroomBuilder_FrequentlyQuestionsTwoColumns_Meta.default ? Component_mushroomBuilder_FrequentlyQuestionsTwoColumns_Meta.default : { friendlyName: 'FrequentlyQuestionsTwoColumns' }
  },
  {
    name: 'Header',
    friendlyName: 'Header-4',
    component: Component_mushroomBuilder_Header,
    metadata: Component_mushroomBuilder_Header_Meta && Component_mushroomBuilder_Header_Meta.default ? Component_mushroomBuilder_Header_Meta.default : { friendlyName: 'Header-4' }
  },
  {
    name: 'Hero',
    friendlyName: 'Hero-3',
    component: Component_mushroomBuilder_Hero,
    metadata: Component_mushroomBuilder_Hero_Meta && Component_mushroomBuilder_Hero_Meta.default ? Component_mushroomBuilder_Hero_Meta.default : { friendlyName: 'Hero-3' }
  },
  {
    name: 'ImageFeatureList',
    friendlyName: 'ImageFeatureList',
    component: Component_mushroomBuilder_ImageFeatureList,
    metadata: Component_mushroomBuilder_ImageFeatureList_Meta && Component_mushroomBuilder_ImageFeatureList_Meta.default ? Component_mushroomBuilder_ImageFeatureList_Meta.default : { friendlyName: 'ImageFeatureList' }
  },
  {
    name: 'ReviewWithTitle',
    friendlyName: 'Review with title',
    component: Component_mushroomBuilder_ReviewWithTitle,
    metadata: Component_mushroomBuilder_ReviewWithTitle_Meta && Component_mushroomBuilder_ReviewWithTitle_Meta.default ? Component_mushroomBuilder_ReviewWithTitle_Meta.default : { friendlyName: 'Review with title' }
  },
  {
    name: 'TableCompare',
    friendlyName: 'ComparisonSectionProduct',
    component: Component_mushroomBuilder_TableCompare,
    metadata: Component_mushroomBuilder_TableCompare_Meta && Component_mushroomBuilder_TableCompare_Meta.default ? Component_mushroomBuilder_TableCompare_Meta.default : { friendlyName: 'ComparisonSectionProduct' }
  },
  {
    name: 'Banner',
    friendlyName: 'Banner',
    component: Component_mushroomNewBuilder_Banner,
    metadata: Component_mushroomNewBuilder_Banner_Meta && Component_mushroomNewBuilder_Banner_Meta.default ? Component_mushroomNewBuilder_Banner_Meta.default : { friendlyName: 'Banner' }
  },
  {
    name: 'ContentWithLeftImages',
    friendlyName: 'Content With Left Images',
    component: Component_mushroomNewBuilder_ContentWithLeftImages,
    metadata: Component_mushroomNewBuilder_ContentWithLeftImages_Meta && Component_mushroomNewBuilder_ContentWithLeftImages_Meta.default ? Component_mushroomNewBuilder_ContentWithLeftImages_Meta.default : { friendlyName: 'Content With Left Images' }
  },
  {
    name: 'DescriptionWithIcons',
    friendlyName: 'Description With Icons',
    component: Component_mushroomNewBuilder_DescriptionWithIcons,
    metadata: Component_mushroomNewBuilder_DescriptionWithIcons_Meta && Component_mushroomNewBuilder_DescriptionWithIcons_Meta.default ? Component_mushroomNewBuilder_DescriptionWithIcons_Meta.default : { friendlyName: 'Description With Icons' }
  },
  {
    name: 'Footer',
    friendlyName: 'Footer Old',
    component: Component_mushroomNewBuilder_Footer,
    metadata: Component_mushroomNewBuilder_Footer_Meta && Component_mushroomNewBuilder_Footer_Meta.default ? Component_mushroomNewBuilder_Footer_Meta.default : { friendlyName: 'Footer Old' }
  },
  {
    name: 'FrequentlyQuestions',
    friendlyName: 'Frequently Questions With CTA',
    component: Component_mushroomNewBuilder_FrequentlyQuestions,
    metadata: Component_mushroomNewBuilder_FrequentlyQuestions_Meta && Component_mushroomNewBuilder_FrequentlyQuestions_Meta.default ? Component_mushroomNewBuilder_FrequentlyQuestions_Meta.default : { friendlyName: 'Frequently Questions With CTA' }
  },
  {
    name: 'Header',
    friendlyName: 'Header-4-small-buttons',
    component: Component_mushroomNewBuilder_Header,
    metadata: Component_mushroomNewBuilder_Header_Meta && Component_mushroomNewBuilder_Header_Meta.default ? Component_mushroomNewBuilder_Header_Meta.default : { friendlyName: 'Header-4-small-buttons' }
  },
  {
    name: 'Hero',
    friendlyName: 'Hero-4',
    component: Component_mushroomNewBuilder_Hero,
    metadata: Component_mushroomNewBuilder_Hero_Meta && Component_mushroomNewBuilder_Hero_Meta.default ? Component_mushroomNewBuilder_Hero_Meta.default : { friendlyName: 'Hero-4' }
  },
  {
    name: 'IconsWithImagesSwiper',
    friendlyName: 'Icons With Images Swiper',
    component: Component_mushroomNewBuilder_IconsWithImagesSwiper,
    metadata: Component_mushroomNewBuilder_IconsWithImagesSwiper_Meta && Component_mushroomNewBuilder_IconsWithImagesSwiper_Meta.default ? Component_mushroomNewBuilder_IconsWithImagesSwiper_Meta.default : { friendlyName: 'Icons With Images Swiper' }
  },
  {
    name: 'ImageReviews',
    friendlyName: 'ImageReviews',
    component: Component_mushroomNewBuilder_ImageReviews,
    metadata: Component_mushroomNewBuilder_ImageReviews_Meta && Component_mushroomNewBuilder_ImageReviews_Meta.default ? Component_mushroomNewBuilder_ImageReviews_Meta.default : { friendlyName: 'ImageReviews' }
  },
  {
    name: 'LogoSwiper',
    friendlyName: 'Logos Swiper',
    component: Component_mushroomNewBuilder_LogoSwiper,
    metadata: Component_mushroomNewBuilder_LogoSwiper_Meta && Component_mushroomNewBuilder_LogoSwiper_Meta.default ? Component_mushroomNewBuilder_LogoSwiper_Meta.default : { friendlyName: 'Logos Swiper' }
  },
  {
    name: 'OptionsProductsWithUpsell',
    friendlyName: 'Options Products With Upsell',
    component: Component_mushroomNewBuilder_OptionsProductsWithUpsell,
    metadata: Component_mushroomNewBuilder_OptionsProductsWithUpsell_Meta && Component_mushroomNewBuilder_OptionsProductsWithUpsell_Meta.default ? Component_mushroomNewBuilder_OptionsProductsWithUpsell_Meta.default : { friendlyName: 'Options Products With Upsell' }
  },
  {
    name: 'RaitingStars',
    friendlyName: 'RaitingStars',
    component: Component_mushroomNewBuilder_RaitingStars,
    metadata: Component_mushroomNewBuilder_RaitingStars_Meta && Component_mushroomNewBuilder_RaitingStars_Meta.default ? Component_mushroomNewBuilder_RaitingStars_Meta.default : { friendlyName: 'RaitingStars' }
  },
  {
    name: 'Reviews',
    friendlyName: 'Review Section With Heading And ProductId',
    component: Component_mushroomNewBuilder_Reviews,
    metadata: Component_mushroomNewBuilder_Reviews_Meta && Component_mushroomNewBuilder_Reviews_Meta.default ? Component_mushroomNewBuilder_Reviews_Meta.default : { friendlyName: 'Review Section With Heading And ProductId' }
  },
  {
    name: 'SaleBanner',
    friendlyName: 'Sale Banner',
    component: Component_mushroomNewBuilder_SaleBanner,
    metadata: Component_mushroomNewBuilder_SaleBanner_Meta && Component_mushroomNewBuilder_SaleBanner_Meta.default ? Component_mushroomNewBuilder_SaleBanner_Meta.default : { friendlyName: 'Sale Banner' }
  },
  {
    name: 'TableWithCheckbox',
    friendlyName: 'Table With Checkbox',
    component: Component_mushroomNewBuilder_TableWithCheckbox,
    metadata: Component_mushroomNewBuilder_TableWithCheckbox_Meta && Component_mushroomNewBuilder_TableWithCheckbox_Meta.default ? Component_mushroomNewBuilder_TableWithCheckbox_Meta.default : { friendlyName: 'Table With Checkbox' }
  },
  {
    name: 'Testimonial',
    friendlyName: 'Testimonials Swiper Auto Height',
    component: Component_mushroomNewBuilder_Testimonial,
    metadata: Component_mushroomNewBuilder_Testimonial_Meta && Component_mushroomNewBuilder_Testimonial_Meta.default ? Component_mushroomNewBuilder_Testimonial_Meta.default : { friendlyName: 'Testimonials Swiper Auto Height' }
  },
  {
    name: 'TitleDescriptionIcons',
    friendlyName: 'Ttitle Description Icons',
    component: Component_mushroomNewBuilder_TitleDescriptionIcons,
    metadata: Component_mushroomNewBuilder_TitleDescriptionIcons_Meta && Component_mushroomNewBuilder_TitleDescriptionIcons_Meta.default ? Component_mushroomNewBuilder_TitleDescriptionIcons_Meta.default : { friendlyName: 'Ttitle Description Icons' }
  },
  {
    name: 'TitleDescriptionsPrice',
    friendlyName: 'TitleDescriptionsPrice',
    component: Component_mushroomNewBuilder_TitleDescriptionsPrice,
    metadata: Component_mushroomNewBuilder_TitleDescriptionsPrice_Meta && Component_mushroomNewBuilder_TitleDescriptionsPrice_Meta.default ? Component_mushroomNewBuilder_TitleDescriptionsPrice_Meta.default : { friendlyName: 'TitleDescriptionsPrice' }
  },
  {
    name: 'TitleDescriptionsPriceDup',
    friendlyName: 'Title Descriptions Price',
    component: Component_mushroomNewBuilder_TitleDescriptionsPriceDup,
    metadata: Component_mushroomNewBuilder_TitleDescriptionsPriceDup_Meta && Component_mushroomNewBuilder_TitleDescriptionsPriceDup_Meta.default ? Component_mushroomNewBuilder_TitleDescriptionsPriceDup_Meta.default : { friendlyName: 'Title Descriptions Price' }
  },
  {
    name: 'Verified',
    friendlyName: 'Verified',
    component: Component_mushroomNewBuilder_Verified,
    metadata: Component_mushroomNewBuilder_Verified_Meta && Component_mushroomNewBuilder_Verified_Meta.default ? Component_mushroomNewBuilder_Verified_Meta.default : { friendlyName: 'Verified' }
  },
  {
    name: 'TitleDescriptionsPrice',
    friendlyName: 'TitleDescriptionsPrice',
    component: Component_mushroomSpecial_TitleDescriptionsPrice,
    metadata: Component_mushroomSpecial_TitleDescriptionsPrice_Meta && Component_mushroomSpecial_TitleDescriptionsPrice_Meta.default ? Component_mushroomSpecial_TitleDescriptionsPrice_Meta.default : { friendlyName: 'TitleDescriptionsPrice' }
  },
  {
    name: 'SubscriptionOverlay',
    friendlyName: 'SubscriptionOverlay',
    component: Component_overlay_SubscriptionOverlay,
    metadata: Component_overlay_SubscriptionOverlay_Meta && Component_overlay_SubscriptionOverlay_Meta.default ? Component_overlay_SubscriptionOverlay_Meta.default : { friendlyName: 'SubscriptionOverlay' }
  },
  {
    name: 'starsRating',
    friendlyName: 'starsRating',
    component: Component_rating_starsRating,
    metadata: Component_rating_starsRating_Meta && Component_rating_starsRating_Meta.default ? Component_rating_starsRating_Meta.default : { friendlyName: 'starsRating' }
  },
  {
    name: 'ReviewProduct',
    friendlyName: 'Review Product',
    component: Component_reviews_ReviewProduct,
    metadata: Component_reviews_ReviewProduct_Meta && Component_reviews_ReviewProduct_Meta.default ? Component_reviews_ReviewProduct_Meta.default : { friendlyName: 'Review Product' }
  },
  {
    name: 'ReviewWithComments',
    friendlyName: 'Review With Comments And ProductId',
    component: Component_reviews_ReviewWithComments,
    metadata: Component_reviews_ReviewWithComments_Meta && Component_reviews_ReviewWithComments_Meta.default ? Component_reviews_ReviewWithComments_Meta.default : { friendlyName: 'Review With Comments And ProductId' }
  },
  {
    name: 'BoxSeason',
    friendlyName: 'SipsBoxSeason',
    component: Component_sipsBuilder_BoxSeason,
    metadata: Component_sipsBuilder_BoxSeason_Meta && Component_sipsBuilder_BoxSeason_Meta.default ? Component_sipsBuilder_BoxSeason_Meta.default : { friendlyName: 'SipsBoxSeason' }
  },
  {
    name: 'BoxSixCustomCuratedFlavors',
    friendlyName: 'BoxSixCustomCuratedFlavors',
    component: Component_sipsBuilder_BoxSixCustomCuratedFlavors,
    metadata: Component_sipsBuilder_BoxSixCustomCuratedFlavors_Meta && Component_sipsBuilder_BoxSixCustomCuratedFlavors_Meta.default ? Component_sipsBuilder_BoxSixCustomCuratedFlavors_Meta.default : { friendlyName: 'BoxSixCustomCuratedFlavors' }
  },
  {
    name: 'Footer1',
    friendlyName: 'Footer1',
    component: Component_sipsBuilder_Footer1,
    metadata: Component_sipsBuilder_Footer1_Meta && Component_sipsBuilder_Footer1_Meta.default ? Component_sipsBuilder_Footer1_Meta.default : { friendlyName: 'Footer1' }
  },
  {
    name: 'HowItWorks',
    friendlyName: 'HowItWorks',
    component: Component_sipsBuilder_HowItWorks,
    metadata: Component_sipsBuilder_HowItWorks_Meta && Component_sipsBuilder_HowItWorks_Meta.default ? Component_sipsBuilder_HowItWorks_Meta.default : { friendlyName: 'HowItWorks' }
  },
  {
    name: 'Questions',
    friendlyName: 'Questions',
    component: Component_sipsBuilder_Questions,
    metadata: Component_sipsBuilder_Questions_Meta && Component_sipsBuilder_Questions_Meta.default ? Component_sipsBuilder_Questions_Meta.default : { friendlyName: 'Questions' }
  },
  {
    name: 'Reviews',
    friendlyName: 'Reviews',
    component: Component_sipsBuilder_Reviews,
    metadata: Component_sipsBuilder_Reviews_Meta && Component_sipsBuilder_Reviews_Meta.default ? Component_sipsBuilder_Reviews_Meta.default : { friendlyName: 'Reviews' }
  },
  {
    name: 'Schedule',
    friendlyName: 'Schedule',
    component: Component_sipsBuilder_Schedule,
    metadata: Component_sipsBuilder_Schedule_Meta && Component_sipsBuilder_Schedule_Meta.default ? Component_sipsBuilder_Schedule_Meta.default : { friendlyName: 'Schedule' }
  },
  {
    name: 'SeasonalSipsClub',
    friendlyName: 'SeasonalSipsClub',
    component: Component_sipsBuilder_SeasonalSipsClub,
    metadata: Component_sipsBuilder_SeasonalSipsClub_Meta && Component_sipsBuilder_SeasonalSipsClub_Meta.default ? Component_sipsBuilder_SeasonalSipsClub_Meta.default : { friendlyName: 'SeasonalSipsClub' }
  },
  {
    name: 'WhyChooseLifeboost',
    friendlyName: 'WhyChooseLifeboost',
    component: Component_sipsBuilder_WhyChooseLifeboost,
    metadata: Component_sipsBuilder_WhyChooseLifeboost_Meta && Component_sipsBuilder_WhyChooseLifeboost_Meta.default ? Component_sipsBuilder_WhyChooseLifeboost_Meta.default : { friendlyName: 'WhyChooseLifeboost' }
  },
  {
    name: 'Content_video',
    friendlyName: 'Content_video',
    component: Component_strawberry_Content_video,
    metadata: Component_strawberry_Content_video_Meta && Component_strawberry_Content_video_Meta.default ? Component_strawberry_Content_video_Meta.default : { friendlyName: 'Content_video' }
  },
  {
    name: 'Subscription',
    friendlyName: 'SwatchesSubscription',
    component: Component_swatches_Subscription,
    metadata: Component_swatches_Subscription_Meta && Component_swatches_Subscription_Meta.default ? Component_swatches_Subscription_Meta.default : { friendlyName: 'SwatchesSubscription' }
  },
  {
    name: 'SwatchesWithSwiper',
    friendlyName: 'SwatchesWithSwiper',
    component: Component_swatches_SwatchesWithSwiper,
    metadata: Component_swatches_SwatchesWithSwiper_Meta && Component_swatches_SwatchesWithSwiper_Meta.default ? Component_swatches_SwatchesWithSwiper_Meta.default : { friendlyName: 'SwatchesWithSwiper' }
  },
  {
    name: 'CardGrid',
    friendlyName: 'TestimonialsCardGrid',
    component: Component_testimonials_CardGrid,
    metadata: Component_testimonials_CardGrid_Meta && Component_testimonials_CardGrid_Meta.default ? Component_testimonials_CardGrid_Meta.default : { friendlyName: 'TestimonialsCardGrid' }
  },
  {
    name: 'CardGridShadow',
    friendlyName: 'TestimonialsCardGridShadow',
    component: Component_testimonials_CardGridShadow,
    metadata: Component_testimonials_CardGridShadow_Meta && Component_testimonials_CardGridShadow_Meta.default ? Component_testimonials_CardGridShadow_Meta.default : { friendlyName: 'TestimonialsCardGridShadow' }
  },
  {
    name: 'ImageReviews',
    friendlyName: 'ImageReviewsGallery',
    component: Component_testimonials_ImageReviews,
    metadata: Component_testimonials_ImageReviews_Meta && Component_testimonials_ImageReviews_Meta.default ? Component_testimonials_ImageReviews_Meta.default : { friendlyName: 'ImageReviewsGallery' }
  },
  {
    name: 'ListImageInfo',
    friendlyName: 'ListImageInfo',
    component: Component_testimonials_ListImageInfo,
    metadata: Component_testimonials_ListImageInfo_Meta && Component_testimonials_ListImageInfo_Meta.default ? Component_testimonials_ListImageInfo_Meta.default : { friendlyName: 'ListImageInfo' }
  },
  {
    name: 'ListImageInfoRight',
    friendlyName: 'ListImageInfoRight',
    component: Component_testimonials_ListImageInfoRight,
    metadata: Component_testimonials_ListImageInfoRight_Meta && Component_testimonials_ListImageInfoRight_Meta.default ? Component_testimonials_ListImageInfoRight_Meta.default : { friendlyName: 'ListImageInfoRight' }
  },
  {
    name: 'ListInfoLeft',
    friendlyName: 'TestimonialsListInfoLeft',
    component: Component_testimonials_ListInfoLeft,
    metadata: Component_testimonials_ListInfoLeft_Meta && Component_testimonials_ListInfoLeft_Meta.default ? Component_testimonials_ListInfoLeft_Meta.default : { friendlyName: 'TestimonialsListInfoLeft' }
  },
  {
    name: 'ListWithText',
    friendlyName: 'TestimonialsListWithText',
    component: Component_testimonials_ListWithText,
    metadata: Component_testimonials_ListWithText_Meta && Component_testimonials_ListWithText_Meta.default ? Component_testimonials_ListWithText_Meta.default : { friendlyName: 'TestimonialsListWithText' }
  },
  {
    name: 'ListWithTextCta',
    friendlyName: 'TestimonialsListWithTextCta',
    component: Component_testimonials_ListWithTextCta,
    metadata: Component_testimonials_ListWithTextCta_Meta && Component_testimonials_ListWithTextCta_Meta.default ? Component_testimonials_ListWithTextCta_Meta.default : { friendlyName: 'TestimonialsListWithTextCta' }
  },
  {
    name: 'ReviewGrid',
    friendlyName: 'TestimonialsReviewGrid',
    component: Component_testimonials_ReviewGrid,
    metadata: Component_testimonials_ReviewGrid_Meta && Component_testimonials_ReviewGrid_Meta.default ? Component_testimonials_ReviewGrid_Meta.default : { friendlyName: 'TestimonialsReviewGrid' }
  },
  {
    name: 'HeadingImageWithText',
    friendlyName: 'HeadingImageWhitText',
    component: Component_textBlocks_HeadingImageWithText,
    metadata: Component_textBlocks_HeadingImageWithText_Meta && Component_textBlocks_HeadingImageWithText_Meta.default ? Component_textBlocks_HeadingImageWithText_Meta.default : { friendlyName: 'HeadingImageWhitText' }
  },
  {
    name: 'HeadingWhitText',
    friendlyName: 'HeadingWhitText',
    component: Component_textBlocks_HeadingWhitText,
    metadata: Component_textBlocks_HeadingWhitText_Meta && Component_textBlocks_HeadingWhitText_Meta.default ? Component_textBlocks_HeadingWhitText_Meta.default : { friendlyName: 'HeadingWhitText' }
  },
  {
    name: 'AlertsAnimations',
    friendlyName: 'TickersAlertsAnimations',
    component: Component_tickers_AlertsAnimations,
    metadata: Component_tickers_AlertsAnimations_Meta && Component_tickers_AlertsAnimations_Meta.default ? Component_tickers_AlertsAnimations_Meta.default : { friendlyName: 'TickersAlertsAnimations' }
  },
  {
    name: 'BackgroundImageWithCheckList',
    friendlyName: 'Background Image With Check List',
    component: Component_zipifyBuilder_BackgroundImageWithCheckList,
    metadata: Component_zipifyBuilder_BackgroundImageWithCheckList_Meta && Component_zipifyBuilder_BackgroundImageWithCheckList_Meta.default ? Component_zipifyBuilder_BackgroundImageWithCheckList_Meta.default : { friendlyName: 'Background Image With Check List' }
  },
  {
    name: 'BgTexImage',
    friendlyName: 'Background Text Image Logo',
    component: Component_zipifyBuilder_BgTexImage,
    metadata: Component_zipifyBuilder_BgTexImage_Meta && Component_zipifyBuilder_BgTexImage_Meta.default ? Component_zipifyBuilder_BgTexImage_Meta.default : { friendlyName: 'Background Text Image Logo' }
  },
  {
    name: 'ContentWithLeftImage',
    friendlyName: 'Content With Left Image',
    component: Component_zipifyBuilder_ContentWithLeftImage,
    metadata: Component_zipifyBuilder_ContentWithLeftImage_Meta && Component_zipifyBuilder_ContentWithLeftImage_Meta.default ? Component_zipifyBuilder_ContentWithLeftImage_Meta.default : { friendlyName: 'Content With Left Image' }
  },
  {
    name: 'DescriptionLeftRightImage',
    friendlyName: 'Description Left Right Image',
    component: Component_zipifyBuilder_DescriptionLeftRightImage,
    metadata: Component_zipifyBuilder_DescriptionLeftRightImage_Meta && Component_zipifyBuilder_DescriptionLeftRightImage_Meta.default ? Component_zipifyBuilder_DescriptionLeftRightImage_Meta.default : { friendlyName: 'Description Left Right Image' }
  },
  {
    name: 'DescriptionListWithImage',
    friendlyName: 'Description List With Image',
    component: Component_zipifyBuilder_DescriptionListWithImage,
    metadata: Component_zipifyBuilder_DescriptionListWithImage_Meta && Component_zipifyBuilder_DescriptionListWithImage_Meta.default ? Component_zipifyBuilder_DescriptionListWithImage_Meta.default : { friendlyName: 'Description List With Image' }
  },
  {
    name: 'Header',
    friendlyName: 'Header with CTA',
    component: Component_zipifyBuilder_Header,
    metadata: Component_zipifyBuilder_Header_Meta && Component_zipifyBuilder_Header_Meta.default ? Component_zipifyBuilder_Header_Meta.default : { friendlyName: 'Header with CTA' }
  },
  {
    name: 'HeroBackgroundAndImage',
    friendlyName: 'Hero Background And Image',
    component: Component_zipifyBuilder_HeroBackgroundAndImage,
    metadata: Component_zipifyBuilder_HeroBackgroundAndImage_Meta && Component_zipifyBuilder_HeroBackgroundAndImage_Meta.default ? Component_zipifyBuilder_HeroBackgroundAndImage_Meta.default : { friendlyName: 'Hero Background And Image' }
  },
  {
    name: 'HeroWithBackground',
    friendlyName: 'Hero with Background',
    component: Component_zipifyBuilder_HeroWithBackground,
    metadata: Component_zipifyBuilder_HeroWithBackground_Meta && Component_zipifyBuilder_HeroWithBackground_Meta.default ? Component_zipifyBuilder_HeroWithBackground_Meta.default : { friendlyName: 'Hero with Background' }
  },
  {
    name: 'ImageWhitQuote',
    friendlyName: 'Background Image with Quote',
    component: Component_zipifyBuilder_ImageWhitQuote,
    metadata: Component_zipifyBuilder_ImageWhitQuote_Meta && Component_zipifyBuilder_ImageWhitQuote_Meta.default ? Component_zipifyBuilder_ImageWhitQuote_Meta.default : { friendlyName: 'Background Image with Quote' }
  },
  {
    name: 'ImageWithIconsList',
    friendlyName: 'Image With Icons List',
    component: Component_zipifyBuilder_ImageWithIconsList,
    metadata: Component_zipifyBuilder_ImageWithIconsList_Meta && Component_zipifyBuilder_ImageWithIconsList_Meta.default ? Component_zipifyBuilder_ImageWithIconsList_Meta.default : { friendlyName: 'Image With Icons List' }
  },
  {
    name: 'LongTextWithImages',
    friendlyName: 'Long Text With Images',
    component: Component_zipifyBuilder_LongTextWithImages,
    metadata: Component_zipifyBuilder_LongTextWithImages_Meta && Component_zipifyBuilder_LongTextWithImages_Meta.default ? Component_zipifyBuilder_LongTextWithImages_Meta.default : { friendlyName: 'Long Text With Images' }
  },
  {
    name: 'ProductHighlightsAndRecognition',
    friendlyName: 'Content Grid With Icons',
    component: Component_zipifyBuilder_ProductHighlightsAndRecognition,
    metadata: Component_zipifyBuilder_ProductHighlightsAndRecognition_Meta && Component_zipifyBuilder_ProductHighlightsAndRecognition_Meta.default ? Component_zipifyBuilder_ProductHighlightsAndRecognition_Meta.default : { friendlyName: 'Content Grid With Icons' }
  },
  {
    name: 'Swatches',
    friendlyName: 'Swatches Zipify',
    component: Component_zipifyBuilder_Swatches,
    metadata: Component_zipifyBuilder_Swatches_Meta && Component_zipifyBuilder_Swatches_Meta.default ? Component_zipifyBuilder_Swatches_Meta.default : { friendlyName: 'Swatches Zipify' }
  },
  {
    name: 'TestimonialsWithOptionsColors',
    friendlyName: 'Testimonials With Options Colors',
    component: Component_zipifyBuilder_TestimonialsWithOptionsColors,
    metadata: Component_zipifyBuilder_TestimonialsWithOptionsColors_Meta && Component_zipifyBuilder_TestimonialsWithOptionsColors_Meta.default ? Component_zipifyBuilder_TestimonialsWithOptionsColors_Meta.default : { friendlyName: 'Testimonials With Options Colors' }
  },
  {
    name: 'TitleWithImageCTA',
    friendlyName: 'Title With Image CTA',
    component: Component_zipifyBuilder_TitleWithImageCTA,
    metadata: Component_zipifyBuilder_TitleWithImageCTA_Meta && Component_zipifyBuilder_TitleWithImageCTA_Meta.default ? Component_zipifyBuilder_TitleWithImageCTA_Meta.default : { friendlyName: 'Title With Image CTA' }
  }
]

export function loadBuilderComponents(friendlyNames) {
  //console.log('[Component Loader] Requested names:', friendlyNames)
  
  if (!friendlyNames || friendlyNames.length === 0) {
    // Load all components
    return allComponents.filter(c => {
      // Skip if explicitly ignored in metadata
      if (c.metadata?.ignored) return false
      // Include if has friendlyName or valid metadata
      return c.friendlyName || c.metadata
    }).map((c) => {
      const friendlyName = c.friendlyName || c.metadata?.friendlyName || c.name || ''
      const metadata = c.metadata || {}
      
      return {
        friendlyName: friendlyName,
        name: friendlyName,
        component: c.component,
        inputs: metadata.inputs || [],
        canHaveChildren: metadata.canHaveChildren !== false,
        ...(metadata.description && { description: metadata.description }),
        ...(metadata.schema && { schema: metadata.schema })
      }
    })
  }
  
  // Load only requested components
  const requested = []
  for (const requestedName of friendlyNames) {
    const found = allComponents.find(c => {
      // First try the friendlyName from the component object itself
      if (c.friendlyName) {
        const matches = c.friendlyName === requestedName ||
               c.friendlyName.toLowerCase() === requestedName.toLowerCase()
        
        if (!matches) {
          // Try matching without spaces/special chars
          const normalizedRequested = requestedName.replace(/[s-]+/g, '').toLowerCase()
          const normalizedFriendly = c.friendlyName.replace(/[s-]+/g, '').toLowerCase()
          return normalizedFriendly === normalizedRequested
        }
        
        return matches
      }
      
      // Fallback to metadata if available
      if (!c.metadata) return false
      const meta = c.metadata
      const matches = meta.friendlyName === requestedName ||
             meta.friendlyName?.toLowerCase() === requestedName.toLowerCase() ||
             c.name === requestedName ||
             c.name.toLowerCase() === requestedName.toLowerCase()
      
      if (!matches && meta.friendlyName) {
        // Try matching without spaces/special chars
        const normalizedRequested = requestedName.replace(/[s-]+/g, '').toLowerCase()
        const normalizedFriendly = meta.friendlyName.replace(/[s-]+/g, '').toLowerCase()
        return normalizedFriendly === normalizedRequested
      }
      
      return matches
    })
    
    if (found) {
      const friendlyName = found.friendlyName || found.metadata?.friendlyName || found.name
      const metadata = found.metadata || {}
      
      //console.log('[Component Loader] Found component for', requestedName, ':', friendlyName)
      requested.push({
        friendlyName: friendlyName,
        name: friendlyName,
        component: found.component,
        inputs: metadata.inputs || [],
        canHaveChildren: metadata.canHaveChildren !== false,
        ...(metadata.description && { description: metadata.description }),
        ...(metadata.schema && { schema: metadata.schema })
      })
    } else {
      console.log('[Component Loader] No match found for:', requestedName)
    }
  }
  
  //console.log('[Component Loader] Returning', requested.length, 'components')
  return requested
}
